<template>
<a-spin :tip="spinMessage" :spinning="spinning">
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
              <span class="alert-inner--text"> {{errorMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
              <span class="alert-inner--text"> {{successMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
        </div>
        <div class="col-md-5" style="margin-bottom: -50px;">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{selectedDocumentName}}
          </h3>
          <h6 class="text-small text-muted mb-4" :class="type === 'dark' ? 'text-white'  : ''">
            Selected: {{checkedItems.length}}
          </h6>
        </div>
        <div class="col-md-7 text-right">
        <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="(currentDocumentTypeCode == 'OTHTOV' || currentDocumentTypeCode == 'OTHPCV') && checkedItems.length > 0" class="dropdown-item">
                <a-popconfirm title="You are about to void the selected record?" @confirm="deleteMultipleRow()" okText="Void" cancelText="Cancel">
                  <i class="fa fa-trash"></i>
                  <span class="text-danger" style="margin-left: 20px;">Void Selected</span>
                </a-popconfirm>
              </div>
              <div v-if="accessRights.includes('T')" class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                  <i class="fa fa-print"></i>
                  <span>Print <a-badge count="SOON" :number-style="{ backgroundColor: '#52c41a' }" /></span>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('E')" @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" v-if="['RELSLO','RECADJ','ORIPOX','ORISOX'].includes(currentDocumentTypeCode)" @click.prevent="showActionDrawer('massAddWithHeader')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('G')" @click.prevent="showActionDrawer('configure')">
                  <i class="ni ni-settings-gear-65"></i>
                  <span>Configure</span>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('G')" @click.prevent="showActionDrawer('configurationhist')">
                <i class="fa fa-history"></i>
                <span>Configuration History</span>
            </div>
            </template>
          </base-dropdown>
          <div v-if="checkedItems.length == 0 && accessRights.includes('A') && currentDocumentTypeCode!='RECTRX' && currentDocumentTypeCode!='OTHTOV' && currentDocumentTypeCode!='OTHPCV'">
            <div v-if='currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN" || currentDocumentTypeCode=="OTHSBI" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="OTHCNS" || currentDocumentTypeCode=="RECCSR" || currentDocumentTypeCode=="RECCSI" || currentDocumentTypeCode=="ORIOCR" || currentDocumentTypeCode=="ORORSO" || currentDocumentTypeCode=="OTHBAR"'>
               <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDocumentDrawer(selectedDocumentName)">Create {{selectedDocumentName}} </base-button>
            </div>
            <div v-else>
              <router-link  :to="{ name: 'document_form', params: { id: -1, document_type_id:documentTypeDetails.documentTypeId,document_typex:documentTypex,documentTypeName:documentTypeDetails.documentTypeName,documentTypeCode:documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:documentTypeDetails.documentTypeFriendlyCode} }" v-if='!isRestrictedWithoutOriginDoc'>
                <base-button v-if='currentDocumentTypeCode!="OTHPCK" && currentDocumentTypeCode!="OTHLIQ" && currentDocumentTypeCode!="RECSLI"' class="float-right ml-1" type="primary" size="sm">Create {{selectedDocumentName}}</base-button>
              </router-link>
            </div>
          </div>
          <div v-else></div>
          <div v-if="checkedItems.length > 0 && accessRights.includes('A') && currentDocumentTypeCode=='RELDDE'">
            <div>
               <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="GenerateBatchPickingList()">Generate Batch Picking List</base-button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
       <div v-if="profileAction == 'customize_list'">
         <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
          <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
              <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                  <div class="row">
                      <div class="col-md-6">
                          AVAILABLE FIELDS
                      </div>
                      <div class="col-md-6">
                         <a-checkbox @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)" class="float-right"/>
                      </div>
                   </div>
              </li>
              <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields">
                   <div class="row">
                       <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field}}
                      </div>
                      <div class="col-md-6">
                          <a-checkbox @change="onCheckField(field)" :checked="fields.includes(field)" class="float-right"/>
                      </div>
                   </div>
              </li>
          </ul>
       </div>

       <div v-if="profileAction == 'export_list'">
         <h6 class="heading-small text-muted mb-4">Export Options</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
              <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </base-alert>

          <div>
            <a-radio-group v-model="exportSelection">
              <a-radio :style="radioStyle" :value="0">Export All</a-radio>
              <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
              <!-- <a-radio :style="radioStyle" :value="2">Export Selected on Current Page</a-radio> -->
              <a-radio :style="radioStyle" :value="3">Export Selected on All Pages</a-radio>
              <a-radio :style="radioStyle" :value="4">Export Based on Filters</a-radio>
            </a-radio-group>
          </div>
          <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-success float-right" v-if="currentDocumentTypeCode=='OTHSIN'" @click.prevent="download(1)">Export NS Template</button>
            <button type="button" class="btn btn-primary float-right" @click.prevent="download(0)">Export</button>
          </div>
        </div>
        <div v-if="profileAction == 'print_list'">
          <h6 class="heading-small text-muted mb-4">Print Options</h6>
        </div>
    </a-drawer>

    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="configVisible">
        <div v-if="profileAction == 'configure'">
          <document-configuration @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"></document-configuration>
        </div>
    </a-drawer>

    <!-- Drawer for Document header with lines Mass Add -->
    <a-drawer :width="480" placement="right" @close="onClose" :visible="massAddWithHeaderDrawerVisible">
        <h6 class="heading-small text-muted mb-4">Import document header with lines</h6>
        <base-alert v-if="importDocumentHeaderWithLineErrors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in importDocumentHeaderWithLineErrors" :key="error">{{ error }}</li>
        </base-alert>
        
        <div>
            <a-spin tip="Validating CSV file" :spinning="spinning">
                <a-upload-dragger :before-upload="beforeUploadWithHeader"
                    :remove="handleRemove"
                    :fileList="fileList"
                    :multiple="false" accept=".csv, .CSV">
                    <span class="fa fa-file-import" style="font: 20pt;" />
                    <p class="ant-upload-text">Click or drag file to this area to upload</p>
                    <p class="ant-upload-hint">
                          Upload your product list in a CSV file following the specified format.
                          Please upload maximum of 10000 lines per batch.
                          You can download template below.
                    </p>
                </a-upload-dragger>

                <br><br>

                <a-collapse>
                    <a-collapse-panel header="Templates" key="1">
                    <a-list bordered>
                        <a-list-item v-if="['RECADJ'].includes(currentDocumentTypeCode)">
                          <a-list-item-meta description="Contains required data to create a document">
                              <a @click.prevent="downloadTemplate('ADJ')" slot="title">Download with Header Document Template</a>
                          </a-list-item-meta>
                          <div><a @click.prevent="downloadTemplate('ADJ')"><span class="fa fa-file-download"/></a></div>
                        </a-list-item>
                        <a-list-item v-if="['RELSLO'].includes(currentDocumentTypeCode)">
                          <a-list-item-meta description="Contains required data to create a document">
                              <a @click.prevent="downloadTemplate('SLO')" slot="title">Download with Header Document Template</a>
                          </a-list-item-meta>
                          <div><a @click.prevent="downloadTemplate('SLO')"><span class="fa fa-file-download"/></a></div>
                        </a-list-item>
                        <a-list-item v-if="['ORISOX'].includes(currentDocumentTypeCode)">
                          <a-list-item-meta description="Contains required data to create a document">
                              <a @click.prevent="downloadTemplate('SO')" slot="title">Download with Header Document Template</a>
                          </a-list-item-meta>
                          <div><a @click.prevent="downloadTemplate('SO')"><span class="fa fa-file-download"/></a></div>
                        </a-list-item>
                        <a-list-item v-if="['ORIPOX'].includes(currentDocumentTypeCode)">
                          <a-list-item-meta description="Contains required data to create a document">
                              <a @click.prevent="downloadTemplate('PO')" slot="title">Download with Header Document Template</a>
                          </a-list-item-meta>
                          <div><a @click.prevent="downloadTemplate('PO')"><span class="fa fa-file-download"/></a></div>
                        </a-list-item>
                    </a-list>
                    </a-collapse-panel>
                </a-collapse>
            </a-spin>
        </div>
        <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" v-if="importDocumentHeaderWithLineErrors.length < 1 && csvData!='' && spinning == false" class="btn btn-primary float-right" @click.prevent="importFileWithHeader">Import</button>
        </div>
    </a-drawer>

    <a-drawer title="" :width="1200" placement="right" @close="onClose" :visible="configHistoryVisible">
        <div v-if="profileAction == 'configurationhist'">
          <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"></document-configuration-history>
        </div>
    </a-drawer>

    <a-drawer title="" wrapClassName='document-form-drawer' :width="windowWidth" placement="right" @close="onClose" :visible="visible">
        <div>
          <!-- <dynamic-form :parameters="JSON.stringify(documentType)" :convertedJson="convertedJson" :key="componentKey"></dynamic-form> <hr> -->
          <document-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :documentNumber="documentNumber"></document-form>
        </div>
    </a-drawer>
    <div class="table-responsive">
      <a-spin :spinning="loading">
        <vuetable ref="vuetable" v-if="apiURLUpdated"
          :api-url="apiURL"
          :http-options="httpOptions"
          :fields="fields"
          :sort-order="sortOrder"
          :show-sort-icons="true"
          :css="css.table"
          :per-page="perPage"
          no-data-template="Empty"
          pagination-path=""
          data-path="data"
          @vuetable:checkbox-toggled-all="log"
          @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded">   
            <template slot="actions" slot-scope="props">
                <center>
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                      <i class="fa fa-ellipsis-v"> </i>
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item key="1">
                        <router-link  v-if="accessRights.includes('W') || accessRights.includes('V')" :to="{ name: 'document_form', params: { id: props.rowData.id, document_type_id:props.rowData.document_type_id,document_typex:documentTypex,documentTypeName:documentTypeDetails.documentTypeName,documentTypeCode:documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:documentTypeDetails.documentTypeFriendlyCode,documentSiteId:props.rowData.site_id.key} }" >
                          <a class="btn btn-success btn-sm text-white">Open</a>
                        </router-link>
                      </a-menu-item>
                      <a-menu-item key="2">
                        <div v-if="props.rowData.order_source!='lazada' && props.rowData.order_source!='shopee' && props.rowData.order_source!='shopify' && props.rowData.order_source!='zalora'">
                          <a-popconfirm v-if="currentDocumentTypeCode == 'OTHASM' || currentDocumentTypeCode == 'OTHDSM' || currentDocumentTypeCode=='RELDDE' || currentDocumentTypeCode == 'OTHPWS'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id,props.rowData.document_no)" okText="Void" cancelText="Cancel">
                            <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                          <a-popconfirm v-else-if="currentDocumentTypeCode == 'ORORSO' || currentDocumentTypeCode == 'RELTRX' || currentDocumentTypeCode == 'ORISOX'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id,props.rowData.document_no)" okText="Void" cancelText="Cancel">
                            <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted' && props.rowData.status != 'Confirmed'" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                          <a-popconfirm v-else title="You are about to void this record?" @confirm="deleteRow(props.rowData.id, props.rowData.document_no, props.rowData.target_site_id ? props.rowData.target_site_id.label : '')" okText="Void" cancelText="Cancel">
                            <a-button v-if="(props.rowData.status != 'Voided' && props.rowData.status != 'Posted')" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                        </div>
                        <div v-else-if="(props.rowData.order_source=='lazada' || props.rowData.order_source=='shopee' || props.rowData.order_source=='shopify' || props.rowData.order_source=='zalora')">
                          <div v-if="currentDocumentTypeCode=='RELDDE'">
                            <a-popconfirm title="You are about to void this record?" @confirm="deleteEcomOrder(props.rowData)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                          </div>
                          <div v-if="currentDocumentTypeCode!='RELDDE'">
                            <a-popconfirm v-if="currentDocumentTypeCode == 'OTHASM' || currentDocumentTypeCode == 'OTHDSM' || currentDocumentTypeCode == 'OTHPWS'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id,props.rowData.document_no)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                            <a-popconfirm v-else-if="currentDocumentTypeCode == 'ORORSO'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id,props.rowData.document_no)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted' && props.rowData.status != 'Confirmed'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                            <a-popconfirm v-else title="You are about to void this record?" @confirm="deleteRow(props.rowData.id,props.rowData.document_no)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                          </div>
                        </div>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </center>
            </template>
            <template slot="target_date" slot-scope="props">
              <div v-if="props.rowData.order_source=='lazada' || props.rowData.order_source=='shopee' || props.rowData.order_source=='shopify' || props.rowData.order_source=='zalora'">
                <span v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 24" class="text-success font-weight-bold">{{props.rowData.target_date}} </span>
                <span v-else-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 24 && moment(props.rowData.target_date).diff(new Date(), 'hours') > 0" class="text-warning font-weight-bold">{{props.rowData.target_date}} </span>
                <span v-else-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 0" class="text-danger font-weight-bold">{{props.rowData.target_date}} </span>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 24" class="bg-info p-1 text-white rounded">
                  <small class="font-weight-bold">{{moment(props.rowData.target_date).diff(new Date(), "hours")}} hrs left</small>
                </label>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 24 && moment(props.rowData.target_date).diff(new Date(), 'hours') > 0" class="bg-warning p-1 text-white rounded">
                  <small class="font-weight-bold">{{moment(props.rowData.target_date).diff(new Date(), 'hours')}}hr<span v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 1">s</span> left</small>
                </label>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 0" class="bg-danger p-1 text-white rounded">
                  <small class="font-weight-bold">SLA Breached</small>
                </label>
              </div>
            </template>
        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <div class="row justify-content-center align-items-center" v-if="!loading">
          <span class="h5 m-0 pr-1">Page Size</span>
          <select v-model="perPage" @change="onChangePerPage">
            <option v-for="n in perPageOptions" :value="n">{{ n }}</option>
          </select>
        </div>
        <vuetable-pagination ref="pagination" 
        :per-page-options="perPageOptions"
        @vuetable-pagination:change-page="onChangePage" :css="css.pagination"></vuetable-pagination>
      </div>
    </div>

    <!-- Drawer for Delivery Document -->
    <a-drawer title="Please select a sales order document" wrapClassName='document-form-drawer' :width="800" placement="right" @close="onClose" :visible="deliveryDocumentDrawerVisible">
      <VueTabulator ref="tabulator" :options="deliveryDocumentOptions"/>
      <div v-if="allowCreationOfDDWithoutSO" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="DeliveryDocumentNoOrigin">Create without origin document</button>
      </div>
    </a-drawer>

    <!-- Drawer for Re-routed SO -->
    <a-drawer title="Please select a sales order document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="reRoutedSODrawerVisible">
      <VueTabulator ref="tabulator" :options="ReRoutedSOOptions"/>
    </a-drawer>

    <!-- Drawer for Customer Return -->
    <a-drawer title="Please select a Sales Invoice" wrapClassName='document-form-drawer' :width="600" style="display: flex;" placement="right" @close="onClose" :visible="customerReturnDrawerVisible">
      <VueTabulator ref="tabulator" :options="customerReturnOptions"/>
      <router-link  :to="{ name: 'document_form', params: { id: -2, document_type_id:documentTypeDetails.documentTypeId,document_typex:documentTypex,documentTypeName:documentTypeDetails.documentTypeName,documentTypeCode:documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:documentTypeDetails.documentTypeFriendlyCode } }">
        <base-button class="float-right ml-1" style="align-self: flex-end;" type="primary" size="sm">Create Open Customer Return Document</base-button>
      </router-link>
    </a-drawer>

    <!-- Drawer for Online Customer Return -->
    <a-drawer title="Please select an online sales order" wrapClassName='document-form-drawer' :width="600" style="display: flex;" placement="right" @close="onClose" :visible="onlineCustomerReturnDrawerVisible">
      <VueTabulator ref="tabulator" :options="onlineCustomerReturnOptions"/>
      <router-link :to="{ name: 'document_form', params: { id: -2, document_type_id: documentTypeDetails.documentTypeId, document_typex: documentTypex, documentTypeName: documentTypeDetails.documentTypeName, documentTypeCode: documentTypeDetails.documentTypeCode, documentTypeFriendlyCode: documentTypeDetails.documentTypeFriendlyCode } }">
        <base-button class="float-right ml-1" style="align-self: flex-end;" type="primary" size="sm">Create Online Customer Return Document</base-button>
      </router-link>
    </a-drawer>

    <!-- Drawer for Concession Return -->
    <a-drawer title="Please select an concession order" wrapClassName='document-form-drawer' :width="600" style="display: flex;" placement="right" @close="onClose" :visible="concessionReturnDrawerVisible">
      <VueTabulator ref="tabulator" v-model="concessionReturnData" :options="concessionReturnOptions"/>
      <router-link :to="{ name: 'document_form', params: { id: -2, document_type_id: documentTypeDetails.documentTypeId, document_typex: documentTypex, documentTypeName: documentTypeDetails.documentTypeName, documentTypeCode: documentTypeDetails.documentTypeCode, documentTypeFriendlyCode: documentTypeDetails.documentTypeFriendlyCode } }">
        <base-button class="float-right ml-1" style="align-self: flex-end;" type="primary" size="sm">Create Concession Return Document</base-button>
      </router-link>
    </a-drawer>

    <!-- Drawer for Sales Invoice -->
    <a-drawer title="Please select a delivery document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="salesInvoiceDrawerVisible">
      <VueTabulator ref="tabulator" v-model="salesInvoiceData" :options="salesInvoiceOptions"/>
    </a-drawer>

    <!-- Drawer for Suppliers Bill -->
    <a-drawer title="Please select a receiving report document" wrapClassName='document-form-drawer' :width="1000" placement="right" @close="onClose" :visible="suppliersBillDrawerVisible">
      <VueTabulator ref="tabulator" v-model="suppliersBillData" :options="suppliersBillOptions"/>
    </a-drawer>

    <!-- Drawer for Transfer Allocation-- -->
    <a-drawer title="Please select an origin document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="transferAllocationDrawerVisible">
    <base-alert v-if="TAErrorMessage != null" type="danger">
          <span class="alert-inner--text"> {{TAErrorMessage}}</span>
          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <VueTabulator ref="tabulator" :options="transferAllocationOptions"/>

      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="transferAllocationNoOrigin">Create without origin document</button>
      </div>

    </a-drawer>

    <!-- Drawer for Barcode Printing-- -->
    <a-drawer title="Please select an origin document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="barcodePrintingDrawerVisible">
    <base-alert v-if="BPErrorMessage != null" type="danger">
          <span class="alert-inner--text"> {{BPErrorMessage}}</span>
          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <VueTabulator ref="tabulator" :options="barcodePrintingOptions"/>

      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="BarcodePrintingNoOrigin">Create without origin document</button>
      </div>

    </a-drawer>

    <!-- Drawer for Count Set-- -->
    <a-drawer title="Please select a physical count document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="countSetDrawerVisible">
      <base-alert v-if="pcountErrorMessage != null" type="danger">
          <span class="alert-inner--text"> {{pcountErrorMessage}}</span>
          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <VueTabulator ref="tabulator" v-model="countSetData" :options="countSetOptions"/>
      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="countSetClickNext">Next</button>
      </div>
    </a-drawer>

    <!-- Drawer for ecom-- -->
    <a-drawer title="" :width="600" placement="right" @close="onClose" :visible="documentEcomDrawerVisible" v-if="documentEcomDrawerVisible">
      <div>
          <document-ecom-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" @deleteRow="deleteRow" :ecomAction="ecomAction" :documentDetails="documentDetails"> </document-ecom-form>
      </div>
    </a-drawer>
  </div>
</a-spin>
</template>

<script>
  import axios from "axios";
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment';

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js'
  import DocumentForm from '../Documents/DocumentForm.vue'
  import DocumentEcomForm from '../Documents/DocumentEcomForm.vue'

  import DocumentConfiguration from '../Documents/DocumentConfiguration.vue'
  import DocumentConfigurationHistory from '../Documents/DocumentConfigurationHistory.vue'

  var component_x;

  var ORIOROTRQ = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'} , {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var RECTRX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'},{name: 'cas_no', title: 'STI Cas Series'},{name: 'sto_cas_reference', title: 'STO Cas Series'},   { name: 'reference', title: 'Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "brand_names", title: 'Brand'}, {name: "purpose_id.label", title: 'Purpose'}, {name: "remark", title: 'Remarks'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'}, {name: "origin_sublocation", title: 'Sublocation (From)'}, {name: "target_date", title: 'Target Date'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "formatted_amount_net", title: 'Net Amount'}, {name: "formatted_amount_gross", title: 'Gross Amount'}, 
                {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},];
  var RELTRX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: 'cas_no', title: 'STO Cas Series'}, { name: 'reference', title: 'Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "purpose_id.label", title: 'Purpose'}, {name: "brand_names", title: 'Brand'}, {name: "source_site_name", title: 'From'},  {name: "origin_sublocation", title: 'Sublocation (From)'}, {name: "target_site_name", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "order_status", title: 'Order Status'}, {name: "shipping_method_name", title: 'Shipping Method'}, {name: "target_date", title: 'Target Date'}, {name: "remark", title: 'Remarks'},{name: "formatted_amount_net", title: 'Net Amount'}, {name: "formatted_amount_gross", title: 'Gross Amount'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}, {name: "boxme_error_code", title: "Boxme Error Code"}, {name: "boxme_messages", title: "Boxme Messages"}, {name: "boxme_request_id", title: "Boxme Request ID"}]; // Transfer Out
  var RECCSX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "is_exported", title: 'Export Status'}];
  var RECSLI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "origin_sublocation", title: 'From'}, {name: "target_sublocation_id.label", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "brand_names", title: 'Brand'}];
  var RELSLO = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "origin_sublocation", title: 'From'}, {name: "target_sublocation_id.label", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "brand_names", title: 'Brand'},]; // Sublocation Transfer Out
  var ORIPOX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, {name: 'cas_no', title: 'Cas Series'}, { name: 'origin_document_id.label', title: 'Origin#'},  { name: 'document_date', title: 'Document Date'}, { name: 'purpose_id.label', title: 'Purpose'}, { name: 'brand_names', title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: 'target_date', title: 'Target Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name:'payment_term_id.label', title: 'Payment Terms'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "is_exported", title: 'Export Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}]; //FIX ORIGIN#
  var OTHPUR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "is_exported", title: 'Export Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //FIX ORIGIN#
  var RECDEL = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'Origin#'},{name: 'po_cas_reference', title: 'PO Cas Reference'}, {name: 'cas_no',title: 'RR Cas Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "brand_names", title: 'Brand'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "target_site_name", title: 'Deliver To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];  //FIX PO# // Receiving Report
  var RELRSR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Ref#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'},{name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},
                {name: "brand_names", title: 'Brand'}, {name: "order_type", title: 'Order Type'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}]; //Fix Ref#
  var RECRELADJ = ['__checkbox', '__slot:actions', { name: 'document_date', title: 'Document Date'}, {name: 'cas_no', title: 'Cas Series #'}, {name: "created_by", title: 'Created By'}, {name: "status", title: 'Status'}, {name: "site_id.label", title: 'Site'}, { name: 'origin_document_id.label', title: 'Origin Doc'}, {name: "purpose_id.label", title: 'Purpose'}, { name: 'reference', title: 'Reference'},   {name: "total_quantity", title: 'Total Quantity'}, {name: "remark", title: 'Remarks'}, {name: "created_at", title: 'Creation Date'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, { name: 'document_no', title: 'No.', sortField: 'document_no'}]; //Fix Ref#
  var OTHPCN = ['__checkbox', '__slot:actions', { name: 'document_date', title: 'Document Date'}, { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: "party_receiver_name", title: 'Site'},{ name: 'reference', title: 'Reference'}, {name: "total_quantity", title: 'Total Qty'}, {name: "formatted_amount_net", title: 'Total Amount'},  {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'},  {name: "brand_names", title: 'Brand'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}]; //Fix Ref#
  var OTHASMDSM = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "party_receiver_name", title: 'Party'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}]; //Fix Ref#
  var ORISOX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin#'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "salesman_name", title: "Salesman"}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Sublocation'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "payment_status", title: 'Payment Status'}, {name: "formatted_amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "boxme_error_code", title: "Boxme Error Code"}, {name: "boxme_messages", title: "Boxme Messages"}, {name: "boxme_request_id", title: "Boxme Request ID"}];
  
  var OTHSRQ = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'SR NO.', sortField: 'document_no'}, {name: 'job_monitoring_no', title: 'Job Monitoring No'}, { name: 'reference_1', title: 'Customer PO#'}, { name: 'reference_2', title: 'PIML PO#'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer Name'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: "total_quantity", title: 'SR Qty'}, {name: 'actual_quantity', title: 'Actual Qty'}, {name: 'remaining_qty', title: 'Balance Qty'}, {name: "formatted_amount_net", title: 'Sales Amount'}, {name:'currency_id.code', title: 'Sales Amount Currency'}, {name: 'ordering_cost', title: 'Purchase Amount'}, {name: 'ui_currency_id.code', title: 'Purchase Amount Currency'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, { name: 'target_date', title: 'Target Date'}, {name:'shipping_method_name', title: 'Shipment Mode(Incoterms)'}, {name: 'payment_term_name', title: 'Customer Payment Term'   },{name: "customer_country", title: 'Order Source'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  
  var ORIOSO = ['__checkbox', '__slot:actions',  { name: 'document_date', title: 'Document Date'}, { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: "site_id.label", title: 'Site'}, { name: 'reference_2', title: 'Order No.'} , { name: 'reference', title: 'Omisell Ref No'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "oms_status_name", title: 'OMS Status'}, {name: "total_quantity", title: 'Quantity'}, {name: "formatted_amount_net", title: 'Net Amount'}, {name: "payment_status", title: 'Payment Status'}, { name: 'payment_method_1', title: 'Payment Method 1'}, { name: 'payment_method_2', title: 'Payment Method 2'}, { name: 'reference_3', title: 'BoxMe Ref No.'}, {name: "party_name", title: 'Customer'}, {name: "reference_9", title: 'POS Terminal Name'}, {name: "reference_6", title: 'POS Receipt status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "remark", title: 'Remarks'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];
  var RELDDE = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Deliver To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var ORORSO = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "target_site_name", title: 'Target Site'}, {name: "target_sublocation_id.label", title: 'Deliver To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var OTHSIN = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: 'company_id.label',title: 'SBU'}, {name: 'cas_no',title: 'SI Cas Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, { name: "order_source", title: 'Order Source'}, {name: "so_cas_reference", title: "SO Cas Reference"}, { name: 'origin_document_id.origin_reference', title: 'SO Reference No.'}, { name: 'origin_document_id.label', title: 'DD Reference No.'}, {name: "site_id.label", title: 'Site'}, {name: 'brand_names', title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: 'formatted_amount_net', title: 'Net Amount'}, { name: 'formatted_vat_amount', title: 'VAT Amount' }, { name: 'party_tax_type', title: 'Customer Vat Type'}, { name: 'reference', title: 'Reference 1'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "oc_ref_no", title: 'OC Reference No.'},
                  {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];
  var ORISOXSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'Origin #'}, { name: 'reference', title: 'Customer PO#'}, { name: 'reference_2', title: 'PIML PO#'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer Name'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: 'total_quantity', title: 'so_quantity'},{name: "actual_quantity", title: 'Doc Qty'}, {name: 'remaining_qty', title: 'Remaining Qty'}, {name: "formatted_amount_net", title: 'PIML Price Amount'}, {name:'currency_id.label', title: 'PIML Price Currency'}, {name: 'ordering_cost', title: 'Ordering Cost'}, {name: 'ui_currency_id.label', title: 'Ordering Cost Currency'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, { name: 'target_date', title: 'Target Date'}, {name: "supplier_id.label", title: 'Supplier'},
                   {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name:'shipping_method_name', title: 'Shipment Mode(Incoterms)'}, {name: 'payment_term_name', title: 'Payment Term'   },{name: "order_source", title: 'Order Source'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; // Sales Order PIML
  var ORISOXSRCPH = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'reference_2', title: 'Reference 2'}, {name: 'cas_no', title: 'Cas So Series'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "salesman_name", title: "Salesman Name"}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "order_source", title: 'Order Source'}, {name: "brand_names", title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}
                     ,{name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name:'shipping_method_name', title: 'Shipment Mode'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}, {name: "boxme_error_code", title: "Boxme Error Code"}, {name: "boxme_messages", title: "Boxme Messages"}, {name: "boxme_request_id", title: "Boxme Request ID"}]; // Sales Order
  var ORIOSOSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'reference_2', title: 'Reference 2'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "party_name", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "order_source", title: 'Order Source'}, {name: "reference_10", title: 'Releasing Terminal Code'}, {name: "order_source", title: 'Order Source'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "oms_status_name", title: 'OMS Status'}, {name: "payment_status", title: 'Payment Status'}, {name: "formatted_amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},
                    {name: "brand_names", title: 'Brand'}, {name: "order_type", title: 'Order Type'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "reference_10", title: 'Releasing Terminal Code'}, { name: 'is_printed', title: 'SI Printed' }]; // Online Sales Order
  var RELDDESRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'reference_2', title: 'Reference 2'}, {name: 'cas_no', title: 'Cas Dd Series'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "salesman_name", title: "Salesman Name"}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "order_source", title: 'Order Source'}, {name: "brand_names", title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}
                    ,{name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name:'shipping_method_name', title: 'Shipment Mode'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];
  var OTHSINSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: 'company_id.label',title: 'SBU'}, {name: 'cas_no',title: 'SI Cas Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, { name: "order_source", title: 'Order Source'}, {name: "so_cas_reference", title: "SO Cas Reference"}, { name: 'origin_document_id.origin_reference', title: 'SO Reference No.'}, { name: 'origin_document_id.label', title: 'DD Reference No.'}, {name: "site_id.label", title: 'Site'}, {name: 'brand_names', title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: 'formatted_amount_net', title: 'Net Amount'}, { name: 'formatted_vat_amount', title: 'VAT Amount' }, { name: 'party_tax_type', title: 'Customer Vat Type'}, { name: 'reference', title: 'Reference 1'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "oc_ref_no", title: 'OC Reference No.'},
                    {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];
  var OTHSINPIML = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'SI No.', sortField: 'document_no'}, { name: 'so_ref_no.label', title: 'SR#'}, { name: 'origin_document_id.label', title: ' SO#'}, { name: 'reference', title: 'Customer PO#'}, { name: 'reference_2', title: 'PIML PO#'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer Name'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: 'total_quantity', title: 'SI Quantity'}, {name: "formatted_amount_net", title: 'Sales Amount'}, {name:'currency_id.code', title: 'Sales Amount Currency'}, {name: 'ordering_cost_value', title: 'Purchase Amount'}, {name: 'ui_currency_id.code', title: 'Purchase Amount Currency'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, { name: 'target_date', title: 'Target Date'},
                   {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name:'shipping_method_name', title: 'Shipment Mode(Incoterms)'}, {name: 'payment_term_name', title: 'Payment Terms'   },{name: "customer_country", title: 'Ordering Country'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  
  var ORORSOSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "target_site_name", title: 'Target Site'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},
                    {name: "brand_names", title: 'Brand'}, {name: "order_type", title: 'Order Type'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}];
  var OTHLIQ = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Liquidation For'}, {name: "status", title: 'Status'}, {name: "reference_1", title: 'Lessor/Mall Group'}, {name: "formatted_amount_gross", title: 'Gross Amount'}, {name: 'total_discount', title: 'Discount Amount'}, {name: "formatted_net_sales", title: 'Net Sales'}, {name: "trade_discount", title: 'Trade Discount'}, {name: "formatted_amount_net", title: 'Net Receivable'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "reference_2", title: 'Month/Year'}, {name: "remark", title: 'Remarks'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "order_source", title: 'Source'},];
  var OTHSBI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'},{name: "order_source", title: 'Source'}, {name: 'cas_no', title: 'Supplier Bill Cas Series'}, { name: 'is_blended', title: 'WITH ADD ON'} ,{ name: 'origin_document_id.label', title: 'RR/AOC#'}, { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "brand_names", title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Document Amount'}, {name: "currency_id.code", title: 'Currency'}, {name: "currency_rate", title: 'Currency Rate'}, {name: "status", title: 'Status'}, {name: "target_site_name", title: 'Deliver To'}, {name: "order_type", title: 'Order Type'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'},
                {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHPWS = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no' }, { name: 'document_date', title: 'Document Date' }, { name: "site_id.label", title: 'Target Site' }, { name: "brand_filter.label", title: 'Brand' }, { name: 'purpose_id.label', title: 'Purpose' }, { name: "reference_1", title: "Reference" }, { name: "target_date", title: 'Effectivity Date' }, { name: "status", title: 'Status' }, { name: "created_by", title: 'Created By' }, { name: "posted_by", title: 'Posted By' }, { name: "posted_at", title: 'Posted At' }, { name: "deleted_at", title: 'Voided/Cancelled Date' }];
  var ORIASN = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'cas_no', title: 'ASN Cas Series'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin#'},  { name: 'document_date', title: 'Document Date'}, {name: 'purpose_id.label', title: 'Purpose'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: 'target_date', title: 'Target Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "target_site_name", title: 'Deliver To'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "is_exported", title: 'Export Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}, {name: "boxme_error_code", title: "Boxme Error Code"}, {name: "boxme_messages", title: "Boxme Messages"}, {name: "boxme_request_id", title: "Boxme Request ID"}]; //FIX ORIGIN#
  var OTHTRA = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var OTHPCK = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var OTHCNS = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "party_receiver_name", title: 'Party'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Total Amount'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}]; //Fix Ref#
  var RECCSR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: 'company_id.label',title: 'SBU'}, {name: 'cas_no',title: 'CM Cas Reference'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "order_source", title: 'Source'}, { name: 'origin_document_id.label', title: 'DD Reference No.'}, {name: "site_id.label", title: 'Site'}, {name: "brand_names", title: 'Brand'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_net", title: 'Net Amount'},{ name: 'party_tax_type', title: 'Customer Vat Type'}, { name: 'reference', title: 'Reference 1'}, {name: "status", title: 'Status'}, {name: "wms_status_name", title: 'WMS Status'},
  {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}];
  var RECCSI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'CSI Reference No.'},  { name: 'document_date', title: 'Document Date'}, { name: 'reference_2', title: 'Liquidation #'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Return To'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "wms_status_name", title: 'WMS Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},{name: "brand_names", title: 'Brand'}, {name: "order_type", title: 'Order Type'}, {name: "country_id.label", title: 'Country of Origin'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}];
  var ORIOCR = ['__checkbox', '__slot:actions',  { name: 'document_date', title: 'Document Date'}, { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: "site_id.label", title: 'Site'}, { name: 'reference_2', title: 'Order No.'} , { name: 'reference', title: 'Omisell Ref No'}, { name: 'origin_document_id.label', title: 'Origin Document'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "oms_status_name", title: 'OMS Status'}, {name: "total_quantity", title: 'Quantity'}, {name: "formatted_amount_net", title: 'Net Amount'}, { name: 'reference_3', title: 'BoxMe Ref No.'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: 'is_printed', title: 'Is Printed'},{name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "remark", title: 'Remarks'}, {name: "lynexus_log_id", title: "Lynexus Log ID"}];
  var OTHBAR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "status", title: 'Status'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RELCSI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'document_date', title: 'Document Date'}, { name: 'reference_2', title: 'Liquidation #'}, {name: "customer_id.label", title: 'Customer'},{ name: "brand_names", title: 'Brand' }, {name: "site_id.label", title: 'Site'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "formatted_amount_gross", title: 'Gross Sales'}, {name: 'total_discount', title: 'Discount'}, {name: "formatted_amount_net", title: 'Net Sales'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "deleted_at", title: 'Voided/Cancelled Date'},
                 {name: 'discount_text', title: 'Percent Discount'}];
  var OTHTOV = ['__checkbox', '__slot:actions', { name: 'document_date', title: 'Document Date'}, { name: 'document_no', title: 'No.', sortField: 'document_no'}, {name: "status", title: 'Status'}, { name: 'parent_origin_document_id.label', title: 'STO CAS Series'}, {name: "source_site_name", title: 'From'}, {name: "target_site_name", title: 'To'},  { name: 'verification_barcode', title: 'Barcode'}, {name: "verification_variance_quantity", title: 'Variance Qty'}, { name: 'reference', title: 'Reference'}, {name: "remark", title: 'Remarks'}, {name: "resolution", title: 'Resolution'}, { name: "brand_names", title: 'Brand' }, { name: 'origin_document_id.label', title: 'STI CAS Series'}, {name: "origin_sublocation", title: 'Sublocation'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHPCV = ['__checkbox', '__slot:actions', { name: 'document_date', title: 'Document Date'}, {name: "status", title: 'Status'},  { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, {name: "site_id.label", title: 'Site'}, { name: "brand_names", title: 'Brand' }, { name: 'verification_barcode', title: 'Barcode'}, {name: "verification_variance_quantity", title: 'Variance Quantity'}, {name: "formatted_amount_net", title: 'Total Amount'}, {name: "target_sublocation_id.label", title: 'Sublocation'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: 'purpose_id.label', title: 'Purpose'}, {name: "resolution", title: 'Resolution'}];
  var ORISOXSRCPIML = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'SO No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SR#'}, { name: 'reference_1', title: 'Customer PO#'}, { name: 'reference_2', title: 'PIML PO#'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer Name'}, {name: "brand_names", title: 'Brand'}, {name: "fiscal_year", title: 'Fiscal Year'}, {name: "year_season", title: 'Year Season'}, {name: "order_type", title: 'Order Type'}, {name: 'total_quantity', title: 'SO Quantity'},{name: "actual_quantity", title: 'Actual Qty'}, {name: 'remaining_qty', title: 'Balance Qty'}, {name: "formatted_amount_net", title: 'Sales Amount'}, {name:'currency_id.code', title: 'Sales Amount Currency'}, {name: 'ordering_cost_value', title: 'Purchase Amount'}, {name: 'ui_currency_id.code', title: 'Purchase Amount Currency'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, { name: 'target_date', title: 'Target Date'},
                   {name: "country_id.label", title: 'Country of Origin'}, {name: "no_of_cartons", title: 'No. of Cartons'}, {name: "oc_ref_no", title: 'OC Reference No.'}, {name: "shipment_ref_no", title: 'Shipment Reference No.'}, {name:'shipping_method_name', title: 'Shipment Mode(Incoterms)'}, {name: 'payment_term_name', title: 'Customer Payment Terms'},{name: "customer_country", title: 'Ordering Customer'}, {name: "deleted_at", title: 'Voided/Cancelled Date'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; // Sales Order PIML
  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String,
      selectedDocumentName: String
    },
    components: {
        Vuetable,
        VuetablePagination,
        DocumentForm,
        DocumentEcomForm,
        DocumentConfiguration,
        DocumentConfigurationHistory
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType']),
    },
    data() {
      return {
        branchId: secureStorage.getItem("defaultSiteId"),
        proceed_voiding: 0,
        spinMessage: 'Loading ...',
        spinning: false,
        documentTypex: null,
        isSourceMode: null,
        deliveryDocumentOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataFill",
          placeholder:"No Data",
          rowClick: this.salesOrderRowClick,
          showData:[],
          columns: [
            {
            title: 'Document Date',
            field: 'document_date',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'SO#',
            field: 'code_and_document_no',
            sorter: 'number',
            headerFilter:"input"
            },
            {
            title: 'Order Source',
            field: 'order_source',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Customer',
            field: 'customer_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Site',
            field: 'site_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Sublocation',
            field: 'target_sublocation_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
          ],
        },
        barcodePrintingOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          placeholder:"No Data",
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataFill",
          rowClick: this.barcodePrintingRowClick,
          showData:[],
          columns: [
            {
            title: 'Document Type',
            field: 'document_name',
            sorter: 'string',
            headerFilter:"input"
            },
            
            {
            title: 'Document #',
            field: 'code_and_document_no',
            sorter: 'number',
            headerFilter:"input"
            },
            {
            title: 'Document Date',
            field: 'document_date',
            sorter: 'string',
            headerFilter:"input"
            },
          ],
        },
        deliveryDocumentModal: false,
        deliveryDocumentData: [],
        customerReturnData: [],
        customerReturnModal: false,
        customerReturnOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          ajaxFiltering:true,
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          placeholder:"No Data",
          layout:"fitDataFill",
          rowClick: this.salesOrderRowClick,
          showData:[],
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'SI CAS No',
              field: 'si_cas_no',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'DD CAS No',
              field: 'dd_cas_no',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'SO CAS No',
              field: 'so_cas_no',
              sorter: 'string',
              headerFilter:"input"
              },
              // {
              // title: 'DD#',
              // field: 'origin_dd_reference',
              // sorter: 'string',
              // headerFilter:"input"
              // },
              // {
              // title: 'SO#',
              // field: 'origin_so_reference',
              // sorter: 'string',
              // headerFilter:"input"
              // },
              // {
              // title: 'Order Source',
              // field: 'order_source',
              // sorter: 'string',
              // headerFilter:"input"
              // },
              {
              title: 'Customer Name',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Site',
              field: 'site_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              // {
              // title: 'Sublocation',
              // field: 'target_sublocation_id.label',
              // sorter: 'string',
              // headerFilter:"input"
              // },

          ],
        },
        onlineCustomerReturnData: [],
        onlineCustomerReturnModal: false,
        onlineCustomerReturnOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          ajaxFiltering:true,
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          placeholder:"No Data",
          layout:"fitDataFill",
          rowClick: this.salesOrderRowClick,
          columns: [
            {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'OSO#',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
            },
            {
              title: 'Order Source',
              field: 'order_source',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'Customer',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'Site',
              field: 'site_id.label',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'Sublocation',
              field: 'target_sublocation_id.label',
              sorter: 'string',
              headerFilter:"input"
            },
          ],
        },
        concessionReturnData: [],
        concessionReturnModal: false,
        concessionReturnOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          ajaxFiltering:true,
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          placeholder:"No Data",
          layout:"fitDataFill",
          rowClick: this.concessionReturnRowClick,
          columns: [
            {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'CSI#',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
            },
            {
              title: 'Customer',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
            },
            {
              title: 'Site',
              field: 'site_id.label',
              sorter: 'string',
              headerFilter:"input"
            },
          ],
        },
        salesInvoiceOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          ajaxFiltering:true,
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          placeholder:"No Data",
          layout:"fitDataFill",
          rowClick: this.deliveryDocumentRowClick,
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Sales Order',
              field: 'origin_document_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'SO CAS #',
              field: 'cas_no.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Delivery Document',
              field: 'document_no',
              sorter: 'number',
              headerFilter:"input"
              },
              {
              title: 'Customer Code',
              field: 'customer_id.code',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Customer Name',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Tin',
              field: 'customer_id.tin',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Address',
              field: 'customer_id.address',
              sorter: 'string',
              headerFilter:"input"
              },

          ],
        },
        suppliersBillOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataFill",
          placeholder:"No Data",
          rowClick: this.receivingReportRowClick,
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Supplier',
              field: 'supplier_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Receiving Report #',
              field: 'document_no',
              sorter: 'number',
              headerFilter:"input"
              }

          ],
        },
        transferAllocationOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          pagination:"remote",
          placeholder:"No Data",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataFill",
          rowClick: this.transferAllocationRowClick,
          columns: [
              {
              title: 'Document Type',
              field: 'document_name',
              sorter: 'string',
              headerFilter:"input"
              },
              
              {
              title: 'Document #',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
              },
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
          ],
        },
        countSetOptions: {
          pagination:"local",
          paginationSize:10,
          placeholder:"No Data",
          layout:"fitDataFill",
          columns: [
              {
                title: 'Action',
                align:'center',
                formatter: this.addCountSetCheckBox,
                cellClick: this.selectPCountAction
              },
              {
              title: 'PCount Number',
              field: 'code_and_document_no',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Document Type',
              field: 'document_name',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },

          ],
        },
        reRoutedSOModal: false,
        reRoutedSOData: [],
        ReRoutedSOOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
          },
          placeholder:"No Data",
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataFill",
          rowClick: this.salesOrderRowClick,
          showData:[],
          columns: [
            {
            title: 'Document Date',
            field: 'document_date',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'SO#',
            field: 'code_and_document_no',
            sorter: 'number',
            headerFilter:"input"
            },
            {
            title: 'Order Source',
            field: 'order_source',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Customer',
            field: 'customer_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Site',
            field: 'site_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Sublocation',
            field: 'target_sublocation_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
          ],
        },
        currentDocumentTypeCode: null,
        salesInvoiceModal: false,
        salesInvoiceData: [],
        suppliersBillData: [],
        transferAllocationData: [],
        countSetData: [],
        exportSelection: 0,
        accessRights: [],
        isRestrictedWithoutOriginDoc: false,
        documentNumber: 0,
        convertedJson: null,
        documentType: {document_type_id: 0},
        windowWidth: 0,
        errors: [],
        filterStatus: "",
        profileAction: "",
        checkedFields: [],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        modalKey: 0,
        drawerVisible: false,
        configVisible: false,
        massAddWithHeaderDrawerVisible:false,
        configHistoryVisible: false,
        visible: false,
        deliveryDocumentDrawerVisible: false,
        reRoutedSODrawerVisible: false,
        customerReturnDrawerVisible: false,
        onlineCustomerReturnDrawerVisible: false,
        salesInvoiceDrawerVisible: false,
        suppliersBillDrawerVisible: false,
        transferAllocationDrawerVisible: false,
        barcodePrintingDrawerVisible:false,
        countSetDrawerVisible: false,
        concessionReturnDrawerVisible: false,
        apiURL: "",
        isOrderSourceMode: false,
        fields: [],
        sortOrder: [
          {
            field: "id",
            direction: "desc"
          }
        ],
        httpOptions:{
            headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            }
        },
        css: {
            table: {
              tableClass: 'table table-sm table-striped table-bordered table-hovered',
              loadingClass: 'loading'
            },
            pagination: {
              infoClass: 'pull-right',
              wrapperClass: 'vuetable-pagination pull-right',
              activeClass: 'btn-primary btn-sm',
              disabledClass: 'disabled',
              pageClass: 'btn btn-border',
              linkClass: 'btn btn-border',
              icons: {
                first: '',
                prev: '',
                next: '',
                last: '',
              },
            }
        },
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        },
        documentEcomDrawerVisible:false,
        ecomAction:null,
        documentDetails:[],
        documentReferences:[],
        isRestrictedDisplayAllReferences:false,
        isRestrictedDisplayTotalQuantity:false,
        isRestrictedDisplayRemarks:false,
        isRestrictedDisplayShipOnTimeSLA:false,
        selectedPCount:[],
        pcountErrorMessage:null,
        loading: false,
        TAErrorMessage:null,
        BPErrorMessage:null,
        allowCreationOfDDWithoutSO:false,
        apiURLUpdated: false,
        documentTypeDetails:{},
        accountName: secureStorage.getItem("accountName"),
        importDocumentHeaderWithLineErrors:[],
        lineWithHeader:[],
        csvData:[],
        fileList: [],
        perPage:10,
        perPageOptions: [10, 20, 30, 40, 50],
      }
    },
    watch: {
      selectedDocumentName: async function() {
        this.reload()
      },
      currentApiURL: function() {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL
      },
      parameters: function() {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []
        this.checkedItems = []
      },
      perPage: function() {
        // this.$refs.vuetable.reload()
        // this.$refs.vuetable.refresh()
        // this.$refs.pagination.changePage(this.$refs.vuetable.currentPage)
      }
    },
    methods: {
        moment,
        async getCachedRequest(cacheKey, requestUrl) {
          var cachedResponse = secureStorage.getItem(cacheKey)
          if (cachedResponse) return cachedResponse

          var response = await HTTPRequest.getRequest(requestUrl, null)
          if (response) secureStorage.setItem(cacheKey, response)
          return response
        },
        async getDocumentTypeSettingsById(documentTypeId) {
          return await this.getCachedRequest(
            `document_type_settings_${secureStorage.getItem("accountId")}_${documentTypeId}`,
            this.endPoint+'/document_types/get_document_type_settings?id='+ documentTypeId
          )
        },
        async getUserSettings(moduleName) {
          return await this.getCachedRequest(
            `user_settings_${secureStorage.getItem("accountId")}_${secureStorage.getItem("userId")}_${moduleName}`,
            this.endPoint + '/user_settings?user_specific=Y&module_name='+ moduleName
          )
        },
        async getAccountSettings() {
          return await this.getCachedRequest(
            `accountSettings_${secureStorage.getItem("accountId")}`,
            this.endPoint + 'settings/accountSettings?field_name=code'
          )
        },
        async getSystemModule(moduleCode) {
          return await this.getCachedRequest(
            `system_module_${secureStorage.getItem("accountId")}_${moduleCode}`,
            this.endPoint+'/system_modules?status=A&code='+ moduleCode
          )
        },
        async getAccessRights(systemModuleId) {
          // Access rights are security-sensitive: cache in-memory only (per component
          // lifetime) instead of persistent secureStorage, so a revoked/changed
          // permission is never served stale across reloads or logins.
          if (!this._accessRightsCache) this._accessRightsCache = {}
          var cacheKey = String(systemModuleId)
          if (this._accessRightsCache[cacheKey]) return this._accessRightsCache[cacheKey]

          var promise = HTTPRequest.getRequest(
            this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + systemModuleId,
            null
          )
          // Don't keep a rejected promise cached, so a later call can retry.
          promise.catch(() => { delete this._accessRightsCache[cacheKey] })
          this._accessRightsCache[cacheKey] = promise
          return promise
        },
        async reload(){
        this.loading = true
        var currentDocumentTypeId = secureStorage.getItem('documentTypeId')
        var document_config = await this.getDocumentTypeSettingsById(currentDocumentTypeId)
        if(document_config.document_type_settings.references!=undefined){
          this.documentReferences = document_config.document_type_settings.references
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayAllReferences!=undefined){
          this.isRestrictedDisplayAllReferences = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayAllReferences
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayTotalQuantity!=undefined){
          this.isRestrictedDisplayTotalQuantity = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayTotalQuantity
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayRemarks!=undefined){
          this.isRestrictedDisplayRemarks = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayRemarks
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA!=undefined){
          this.isRestrictedDisplayShipOnTimeSLA = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO!=undefined){
          this.allowCreationOfDDWithoutSO = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
        }
        //Document Access Rights
        //var currentDocumentTypeName = secureStorage.getItem('documentTypeName')
        var currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
        this.currentDocumentTypeCode = currentDocumentTypeCode

        var system_module = await this.getSystemModule(currentDocumentTypeCode)
        var accessRightsRequest = await this.getAccessRights(system_module[0].id)


        if (accessRightsRequest.access_rights[system_module[0].id]) {
          this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
        } else {
          this.accessRights = [];
        }

        if (currentDocumentTypeCode=="OROTRQ" && document_config && document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc) {
          this.isRestrictedWithoutOriginDoc = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc
        } else {
          this.isRestrictedWithoutOriginDoc = false
        }

        //Set Order Source
        var isSourceMode = null
        var user_settings = await this.getUserSettings(this.currentDocumentTypeCode);
        if (user_settings.data[0]) isSourceMode = user_settings.data[0].settings_json.isSourceMode
        // Reuse document_config fetched above (by document type id) instead of a
        // second get_document_type_settings call by type_code/trans_code: both the
        // id and the (trans_code + type_code) derived from currentDocumentTypeCode
        // resolve to the same DocumentType, so the returned settings are identical.
        var orisox_doc_config = document_config
        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
            if (isSourceMode == null) isSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode || false
            this.isOrderSourceMode = isSourceMode
        }

        switch(currentDocumentTypeCode) {
          case 'ORITRQ':
            this.fields = ORIOROTRQ
            break;
          case 'OROTRQ':
            this.fields = ORIOROTRQ
            break;
          case 'RECTRX':
            this.fields = RECTRX
            break;
          case 'RELTRX':
            this.fields = RELTRX
            break;

          case 'ORICSQ':
            this.fields = ORIOROTRQ
            break;
          case 'OROCSQ':
            this.fields = ORIOROTRQ
            break;
          case 'RECCSX':
            this.fields = RECCSX
            break;
          case 'RELCSX':
            this.fields = RECCSX
            break;
          case 'OTHTRA':
            this.fields = await this.addExtraColumn(OTHTRA,'OTHTRA')
            this.transferAllocationOptions.ajaxURL = this.endPoint+'documents/documents_for_transfer_allocation'
            break;
          case 'OTHPCK':
            this.fields = OTHPCK
            break;
          case 'OTHPUR':
            this.fields = OTHPUR
            break;
          case 'ORIPOX':
            this.fields = await this.addExtraColumn(ORIPOX,'ORIPOX')
            break;
          case 'ORIASN':
            this.fields = ORIASN
            break;
          case 'RECDEL':
            this.fields = await this.addExtraColumn(RECDEL,'RECDEL')
            break;
          case 'RELRSR':
            this.fields = RELRSR
            break;
          case 'RECADJ':
            this.fields = await this.addExtraColumn(RECRELADJ,'RECADJ')
            break;
          case 'RELADJ':
            this.fields = await this.addExtraColumn(RECRELADJ,'RELADJ')
            break;
          case 'OTHUPC':
          case 'OTHPCN':
            this.fields = OTHPCN
            break;
          case 'OTHCNS':
            var pcount = []
            this.fields = OTHCNS
            pcount = await HTTPRequest.getRequest(this.endPoint+'documents/pcount_for_count_set_document', null)
            if (pcount.length > 0){
              this.countSetData = pcount
            }
            break;
          case 'OTHASM':
            this.fields = OTHASMDSM
            break;
          case 'OTHDSM':
            this.fields = OTHASMDSM
            break;
          case 'RELCSI':
            this.fields = RELCSI
            break;
          case 'OTHTOV':
            this.fields = await this.addExtraColumn(OTHTOV,'OTHTOV')
            break;
          case 'OTHPCV':
            this.fields = await this.addExtraColumn(OTHPCV,'OTHPCV')
            break;
          case 'RELSLO':
            this.fields = RELSLO //TEMP
            break;
          case 'RECSLI':
            this.fields = RECSLI //TEMP
            break;
          case 'RECCSR':
            this.fields = RECCSR
            this.customerReturnOptions.ajaxURL = this.endPoint+'documents/customer_return_valid_sources'
            break;
          case 'ORIOCR':
            this.fields = ORIOCR
            this.onlineCustomerReturnOptions.ajaxURL = this.endPoint+'documents/online_customer_return_valid_sources'
            break;
          case 'RECCSI':
            this.fields = RECCSI
            this.concessionReturnOptions.ajaxURL = this.endPoint+'documents/concession_return_valid_sources'
            break;
          case 'OTHPWS':
            this.fields = OTHPWS
            break;
          case 'OTHBAR':
            this.fields = OTHBAR
            this.barcodePrintingOptions.ajaxURL = this.endPoint+'documents/documents_for_barcode_printing'
            break;
          case 'OTHSBIX':
            var receiving_report_documents = []
            receiving_report_documents = await HTTPRequest.getRequest(this.endPoint+'documents/receiving_reports_for_suppliers_bill', null)
            if (receiving_report_documents.length > 0){
              this.suppliersBillData = receiving_report_documents
            }
            this.fields = OTHSBI
            break;
          case 'OTHSBI':
            var receiving_report_documents = []
            this.suppliersBillOptions.ajaxURL = this.endPoint+'documents/receiving_reports_for_suppliers_bill'
            //receiving_report_documents = await HTTPRequest.getRequest(this.endPoint+'documents/receiving_reports_for_suppliers_bill', null)
            if (receiving_report_documents.length > 0){
              this.suppliersBillData = receiving_report_documents
            }
            this.fields = OTHSBI
            break;
          case 'OTHLIQ':
            this.fields = OTHLIQ
            break;
          case 'ORISOX':
            if (this.isOrderSourceMode == true) {
              if (this.accountName.toLowerCase().includes('primerph')) {
                this.fields = await this.addExtraColumn(ORISOXSRCPH, 'ORISOXSRCPH');
              } else {
                this.fields = await this.addExtraColumn(ORISOXSRCPIML,'ORISOXSRCPIML')
              }
              this.apiURL += '&isOrderSource=true'
            }else if (this.isOrderSourceMode == false) {
              if (this.accountName.toLowerCase().includes('primerph')) {
                this.fields = await this.addExtraColumn(ORISOXSRCPH, 'ORISOXSRCPH');
              } else {
                this.fields = await this.addExtraColumn(ORISOXSRCPIML,'ORISOXSRCPIML')
              }
              this.apiURL += '&isOrderSource=false'
            }else {
              this.fields = await this.addExtraColumn(ORISOX,'ORISOX')
            }
            break;
          case 'OTHSRQ':
            if (this.accountName.toLowerCase().includes('primerph')) {
              this.fields = await this.addExtraColumn(ORISOX,'ORISOX')
            } else {
              this.fields = await this.addExtraColumn(OTHSRQ,'OTHSRQ')
            }
            break;
          
          case 'ORIOSO':
            this.fields = ORIOSO
            break;

          case 'RELDDE':
            var sales_orders = []
            if (this.isOrderSourceMode == true) {
              // this.fields = RELDDESRC
              this.fields =  await this.addExtraColumn(RELDDESRC,'RELDDESRC')
              this.apiURL += '&isOrderSource=true'
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=true'
            }else if (this.isOrderSourceMode == false){
              this.fields =  await this.addExtraColumn(RELDDE,'RELDDE')
              this.apiURL += '&isOrderSource=false'
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=false'
            } else {
              this.fields =  await this.addExtraColumn(RELDDE,'RELDDE')
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=true'
            }
            if (sales_orders.length > 0){
              this.deliveryDocumentData = sales_orders
            }
            break;

            case 'OTHSIN':
            var delivery_documents = []
            if (this.isOrderSourceMode == true) {
              if (this.accountName.toLowerCase().includes('piml')) {
                this.fields =  await this.addExtraColumn(OTHSINPIML,'OTHSINPIML')
              } else {
                this.fields =  await this.addExtraColumn(OTHSINSRC,'OTHSINSRC')
              }
              this.apiURL += '&isOrderSource=true'
              this.salesInvoiceOptions.ajaxURL = this.endPoint+'documents/delivery_documents_for_sales_invoice?isOrderSource=true'
            }else if (this.isOrderSourceMode == false){
              if (this.accountName.toLowerCase().includes('piml')) {
                this.fields =  await this.addExtraColumn(OTHSINPIML,'OTHSINPIML')
              } else {
                this.fields =  await this.addExtraColumn(OTHSIN,'OTHSIN')
              }
              this.salesInvoiceOptions.ajaxURL = this.endPoint+'documents/delivery_documents_for_sales_invoice?isOrderSource=false'
            } else {
              this.fields =  await this.addExtraColumn(OTHSIN,'OTHSIN')
              this.salesInvoiceOptions.ajaxURL = this.endPoint+'documents/delivery_documents_for_sales_invoice?isOrderSource=false'
            }
            if (delivery_documents.length > 0){
              this.salesInvoiceData = delivery_documents
            }
            break;

          case 'ORORSO':
            var sales_orders = []
            if (this.isOrderSourceMode == true) {
              // this.fields = RELDDESRC
              this.fields =  await this.addExtraColumn(ORORSOSRC,'ORORSOSRC')
              this.apiURL += '&isOrderSource=true'
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=true'
            }else if (this.isOrderSourceMode == false){
              this.fields =  await this.addExtraColumn(ORORSO,'ORORSO')
              this.apiURL += '&isOrderSource=false'
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=false'
            } else {
              this.fields =  await this.addExtraColumn(ORORSO,'ORORSO')
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=true'
            }
            if (sales_orders.length > 0){
              this.reRoutedSOData = sales_orders
            }
            break;
          default:
              //TEMP
          }
          //Apply Table Field Changes
          this.$nextTick(()=>{
            if (this.$refs.vuetable != undefined) {
              this.$refs.vuetable.normalizeFields();
            }
          })
        },
        async salesOrderRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, sales_order_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
        },
        async concessionReturnRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, concession_return_order_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
        },
        async deliveryDocumentRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, delivery_document_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
        },
        async barcodePrintingRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, barcode_printing_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
        },
        async receivingReportRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, receiving_report_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode,brandId:row._row.data.brand_id,companyId:row._row.data.company_id, orderSource:'receiving_report' } })
        },
        async transferAllocationRowClick(e, row) {
            var check_document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/check_origin_document_lines_for_TA?document_id='+row._row.data.id, null)
            if (check_document_lines["error"] == undefined){
              this.$router.push({ name: 'document_form', params: { id: -1, transfer_allocation_id: row._row.data.id, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
            }else{
              this.TAErrorMessage = check_document_lines["error"]
            }
        },
        async transferAllocationNoOrigin() {
            this.$router.push({ name: 'document_form', params: { id: -1, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode  } })
        },
        async DeliveryDocumentNoOrigin() {
            this.$router.push({ name: 'document_form', params: { id: -1, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode  } })
        },
        async BarcodePrintingNoOrigin() {
            this.$router.push({ name: 'document_form', params: { id: -1, document_type_id:this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode  } })
        },
        ...mapActions(['updateProfileId']),
        closeDrawer(){
          this.onClose();
        },
        refreshPage(){
          this.onClose()
          this.$refs.vuetable.refresh()
          this.successMessage = "Successful Operation"
          this.errorMessage = null
        },
        showModal(id) {
          this.modalKey++;
          if (this.currentDocumentTypeCode == "RELDDE") {
            this.deliveryDocumentModal = true;
          }else if (this.currentDocumentTypeCode == 'OTHSIN') {
            this.salesInvoiceModal = true;
          }else if (this.currentDocumentTypeCode == 'RECCSR'){
            this.customerReturnModal = true;
          }else if ( this.currentDocumentTypeCode == 'ORIOCR'){
            this.onlineCustomerReturnModal = true;
          }else if (this.currentDocumentTypeCode == 'ORORSO') {
            this.reRoutedSOModal = true;
          }else if (this.currentDocumentTypeCode == 'RECCSI'){
            this.concessionReturnModal = true;
          }
          this.updateProfileId(id);
        },
        async showDrawer(id) {
          this.documentNumber = id
          this.componentKey++
          this.updateProfileId(id)
          this.visible = true
        },
        onLoaded(){
          this.loading = false;
        },
        async showActionDrawer(action) {
          if(action == "customize_list"){
            var response = await HTTPRequest.getRequest(this.endPoint + "documents/get_viewable_fields" , null)
            let unsortedFields = response["fields"];
            let sortedFields = this.checkedFields.slice();

            unsortedFields.forEach(fieldName => {
              if (!this.checkedFields.includes(fieldName))
                sortedFields.push(fieldName)
            });

            this.availableFields = sortedFields;
          }
          this.componentKey++
          this.profileAction = action
          if (action == "configure"){
            this.configVisible = true
          } else if(action == "configurationhist") {
            this.configHistoryVisible = true
          } else if(action == "massAddWithHeader") {
            this.massAddWithHeaderDrawerVisible = true
          } else {
            this.drawerVisible = true
          }

        },
        async showDocumentDrawer(profile) {
          this.componentKey++
          if (profile=='Delivery Document'){
            this.deliveryDocumentDrawerVisible = true
          } else if (profile == 'Sales Invoice') {
            this.salesInvoiceDrawerVisible = true
          } else if (profile == 'Customer Return' || profile == 'Customer Credit Memo') {
            this.customerReturnDrawerVisible = true
          } else if (profile == 'Online Customer Return') {
            this.onlineCustomerReturnDrawerVisible = true
          } else if (profile == 'Suppliers Bill') {
            this.suppliersBillDrawerVisible = true
          } else if (profile == 'Transfer Allocation') {
            this.transferAllocationDrawerVisible = true
          } else if (profile == 'Barcode Printing') {
            this.barcodePrintingDrawerVisible = true
          } else if (profile == 'Re-Routed Sales Order') {
            this.reRoutedSODrawerVisible = true
          } else if (profile == 'Count Set') {
            this.countSetDrawerVisible = true
          } else if (profile == 'Concession Returns') {
            this.concessionReturnDrawerVisible = true
          }     
        },
        handleRemove(file) {
          const index = this.fileList.indexOf(file);
          const newFileList = this.fileList.slice();
          newFileList.splice(index, 1);
          this.fileList = newFileList;
        },
        async beforeUploadWithHeader(file) {
          this.fileList = [];
          const reader = new FileReader();
          reader.onload = async e => {
              this.importDocumentHeaderWithLineErrors = []
              var document_details = {};
              var lines_details = [];
              var skulist = [];
              var siteskulist = [];
              var siterefcode_list = [];
              var pricelist = [];
              var qtylist = [];
              this.csvData = '';
              
              var text = e.target.result;
              var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks

              if(lines.length - 1 > 10000)
                  this.importDocumentHeaderWithLineErrors.push('Total lines exceeded.  Please only upload up to 10000 lines.')

              for(var i = 0; i < lines.length; i++) {
                var temp_lines = lines[i].split(',')
                
                if (i == 0){
                  if(this.currentDocumentTypeCode === "RECADJ"){
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2];
                  }else if (this.currentDocumentTypeCode === "RELSLO"){
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + temp_lines[3];
                  }else if(this.currentDocumentTypeCode === "ORIPOX"){
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + temp_lines[3] + ',' + temp_lines[4]+ ',' + temp_lines[5] + ',' + temp_lines[6] + ',' + temp_lines[7] + ',' + temp_lines[8] + ',' + temp_lines[9] + ',' + temp_lines[10] + ',' + temp_lines[11] + ',' + temp_lines[12] + ',' + temp_lines[13] + ',' + temp_lines[14];
                  }else if(this.currentDocumentTypeCode === "ORISOX"){
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + temp_lines[3] + ',' + temp_lines[4]+ ',' + temp_lines[5] + ',' + temp_lines[6] + ',' + temp_lines[7] + ',' + temp_lines[8] + ',' + temp_lines[9] + ',' + temp_lines[10] + ',' + temp_lines[11] + ',' + temp_lines[12] + ',' + temp_lines[13] + ',' + temp_lines[14] + ',' + temp_lines[15];
                  }
                  var importWithHeader = []
                  if(this.currentDocumentTypeCode === "RECADJ"){
                      importWithHeader = ["siterefcode","barcode","qty"]
                  }else if(this.currentDocumentTypeCode === "RELSLO"){
                    importWithHeader = ["siterefcode","subloc_code","barcode","qty"]
                  }else if(this.currentDocumentTypeCode === "ORIPOX"){
                    importWithHeader = ["NAV SITE CODE","VENDOR CODE","DOCUMENT DATE","TARGET DATE","POSTING DATE","CURRENCY CODE","REFERENCE","TOTAL AMOUNT","REMARKS","PRODUCT_NAME","BARCODE","QUANTITY","PRICE","DISCOUNT","SUBTOTAL"]
                  }else if(this.currentDocumentTypeCode === "ORISOX"){
                    importWithHeader = ["NAV SITE CODE","CUSTOMER CODE","SALESMAN CODE","DOCUMENT DATE","TARGET DATE","POSTING DATE","REFERENCE","OVERALL DISCOUNT AMOUNT","TOTAL AMOUNT","REMARKS","SHIPPING METHOD NAME","PRODUCT_NAME","BARCODE","QUANTITY","PRICE","DISCOUNT","SUBTOTAL"]
                  }
                  for(var ii = 0; ii < importWithHeader.length; ii++) {
                      if(lines[i].split(',')[ii] != importWithHeader[ii]){
                        // console.log(lines[i].split(',')[ii]+"===="+importWithHeader[ii])
                          this.importDocumentHeaderWithLineErrors.push('Column names are incorrect and invalid.');
                      }
                  }
                }else{
                  let qty = 0 
                  let barcode = ""
                  if(this.currentDocumentTypeCode === "RECADJ"){
                    qty = parseInt(temp_lines[2])
                    barcode = temp_lines[1]
                    siteskulist.push(temp_lines[0]+''+barcode)
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + parseInt(temp_lines[2]) || 0;
                  }else if (this.currentDocumentTypeCode === "RELSLO"){
                    qty = parseInt(temp_lines[3])
                    barcode = temp_lines[2]
                    siteskulist.push(temp_lines[0]+''+temp_lines[1]+''+barcode)
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + parseInt(temp_lines[3]) || 0;
                  }else if(this.currentDocumentTypeCode === "ORIPOX"){
                    qty = parseInt(temp_lines[11])
                    barcode = temp_lines[10]
                    siteskulist.push(temp_lines[0]+''+temp_lines[1]+''+barcode+''+temp_lines[6])
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + temp_lines[3] + ',' + temp_lines[4]+ ',' + temp_lines[5] + ',' + temp_lines[6] + ',' + temp_lines[7] + ',' + temp_lines[8] + ',' + temp_lines[9] + ',' + temp_lines[10] + ',' + temp_lines[11] + ',' + temp_lines[12] + ',' + temp_lines[13] + ',' + temp_lines[14];
                  }else if(this.currentDocumentTypeCode === "ORISOX"){
                    qty = parseInt(temp_lines[13])
                    barcode = temp_lines[12]
                    siteskulist.push(temp_lines[0]+''+temp_lines[1]+''+barcode+''+temp_lines[6])
                    this.csvData += temp_lines[0] + ',' + temp_lines[1] + ',' + temp_lines[2] + ',' + temp_lines[3] + ',' + temp_lines[4]+ ',' + temp_lines[5] + ',' + temp_lines[6] + ',' + temp_lines[7] + ',' + temp_lines[8] + ',' + temp_lines[9] + ',' + temp_lines[10] + ',' + temp_lines[11] + ',' + temp_lines[12] + ',' + temp_lines[13] + ',' + temp_lines[14] + ',' + temp_lines[15] + ',' + temp_lines[16];
                  }
                  
                  if(typeof qty === 'string')
                      qtylist.push(parseInt(qty))
                  else
                      qtylist.push(parseInt(qty) || 0)

                  skulist.push(barcode)
                  siterefcode_list.push(temp_lines[0])
                }
                if(i < lines.length)
                  this.csvData += '\n'

              }
              // Get duplicate sku's/barcode
              const findDuplicates = (siteskulist) => {
                let sorted_arr = siteskulist.slice().sort();
                let results = [];
                for (let i = 0; i < sorted_arr.length - 1; i++) {
                    if (sorted_arr[i + 1] == sorted_arr[i]) {
                        results.push(sorted_arr[i]);
                    }
                }
                return results;
              }

              // Result duplicate sku's/barcode -> download list
              if(findDuplicates(siteskulist).length > 0) {
                  this.importDocumentHeaderWithLineErrors.push('With duplicate Barcodes');
              }
              // Get 0 / - quantity
              const zQty = qtylist.filter(qty => {
                  if(isNaN(qty))
                      return true
                  else
                      return qty < 1
              });
              if(zQty.length > 0){
                  this.importDocumentHeaderWithLineErrors.push('All quantities must be POSITIVE integers and no blanks/characters/0.');
              }
              // Get blank skus
              const bSku = skulist.filter(sku => sku.length < 1);
              // Result blank skus
              if(bSku.length > 0)
                  this.importDocumentHeaderWithLineErrors.push('File has blank lines that generate rows with no data but with a comma.');

              // Proceed validating if barcodes are valid
              if(this.importDocumentHeaderWithLineErrors.length < 1){
                    // this.getSuppItems(skulist)
                    this.spinning = false;
              }
              this.importDocumentHeaderWithLineErrors = this._.compact(this.importDocumentHeaderWithLineErrors);
              if (this.importDocumentHeaderWithLineErrors.length == 0 && this.importDocumentHeaderWithLineErrors.length == 0) {
                  this.fileList = [...this.fileList, file];
              }
          }
          reader.readAsText(file);
          this.spinning = false;
          return false;
        },
        async getSuppItems(skulist){
          const supplier_param = (this.supplier.key != null && this.supplier.key != "") ? "supplier_ids="+this.supplier.key+"&" : ""
          // var suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&type=document", null);
          let suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products/check_supplier_products?"+supplier_param+"per_page=500", null);
          let supplierProducts = suppItems.products || [];
          var pageCount = suppItems.total_pages
          this.suppItems = [];

          supplierProducts.map(product => {
            this.suppItems.push(product.barcode)
          })

          // Get succeeding records
          if(pageCount > 1) {
            for (var i = 2; i <= pageCount; i++) {
              // suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&page="+i+"&type=document");
              suppItems = await HTTPRequest.getRequest(`${component_x.endPoint}products/check_supplier_products?${supplier_param}per_page=500&page=${i}`, null);
              supplierProducts = suppItems.products || [];
              supplierProducts.map(product => {
                this.suppItems.push(product.barcode)
              })
            }
          }

          let errorBarcodes = []
          this.spinning = false;
          skulist.map(item => {
            if (!this.suppItems.includes(item)) {
              errorBarcodes.push(item);
            }
          })

          const arrNF = skulist.filter(i => !this.suppItems.includes(i))
          if(arrNF.length > 0) {
              this.massAddProductErrors.push(`The following barcodes are not under the selected supplier or does not exist: ${arrNF.join(', ')}`);
              this.massAddProductErrorsDL.push('With duplicate Barcodes');
              this.dlSkusNotFound = 1
              this.dlSkusNotFoundItems = arrNF
          }

          return true;
        },
        downloadTemplate(type){
          let urlDownload = "";
          switch (type) {
            case "ADJ":
              urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=with_header_adj";
            break;
            case "SLO":
              urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=with_header_slo";
            break;
            case "PO":
              urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=with_header_po";
            break;
            case "SO":
              urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=with_header_so";
            break;
            default:
            break;
          }
          axios({
            url:  urlDownload,
            method: 'POST',
            responseType: 'blob', // important
            headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
            }
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'with_header_'+type+'_import_template.csv');
            document.body.appendChild(link);
            link.click();
            component_x.$notification['success']({
                message: 'Successful Download',
                description: "You have succesfully downloaded the template for document upload.",
            });
          });
        },
        importFileWithHeader(){
          this.spinning = true;
          const reader = new FileReader();
          reader.onload = e => {
              // this.processCsvMassAdd(e.target.result);
              this.processCsvMassAdd(this.csvData);
          };
          reader.readAsText(this.fileList[0]);
          this.spinning = false;
          return false;
        },
        async processCsvMassAdd(csvtext){
          this.spinning = true;
          var CsvUploadParams = {'csv_lines': csvtext, type: this.currentDocumentTypeCode, document_type_id: this.documentTypeDetails.documentTypeId}
          let url = `${this.endPoint}documents/mass_add_documents`;
          this.processingCsvUpload = true
          var config = {
              method: 'post',
              url: url,
              headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
              data: CsvUploadParams
          }
          var job;
          await axios(config)
              .then(function (response) {
                  job = response.data
              })
              .catch(function (error) {
                  console.log(error)
          });

          if (job.id > 1) {
              component_x.$notification['success']({
                  message: 'Successful Operation',
                  description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                  btn: h => {
                      return h(
                      'base-button',
                      {
                          props: {
                          type: 'primary',
                          class: 'btn-sm',
                          },
                          on: {
                          click: () => component_x.$router.push("/jobs"),
                          },
                      },
                      'View Jobs',
                      );
                  },
              });
          } else {
              this.documentActionNotification('CSV Upload', 'error');
          }

          this.spinning = false;
          this.onClose();
        },
        onClose() {
          this.errors = [];
          this.configVisible = false
          this.configHistoryVisible = false
          this.drawerVisible = false
          this.massAddWithHeaderDrawerVisible = false
          this.deliveryDocumentDrawerVisible = false
          this.reRoutedSODrawerVisible = false
          this.salesInvoiceDrawerVisible = false
          this.customerReturnDrawerVisible = false
          this.onlineCustomerReturnDrawerVisible = false
          this.suppliersBillDrawerVisible = false
          this.visible = false
          this.transferAllocationDrawerVisible = false
          this.barcodePrintingDrawerVisible = false
          this.documentEcomDrawerVisible = false
          this.countSetDrawerVisible = false
          this.concessionReturnDrawerVisible = false
          this.componentKey++
        },
        log(){
          this.checkedItems = this.$refs.vuetable.selectedTo
        },
        onCheckField(fieldName){
          if(this.fields.includes(fieldName)){
            var indexValue = this.fields.indexOf(fieldName)
            if(indexValue > -1) this.fields.splice(indexValue,1)
            var indexValue2 = this.checkedFields.indexOf(fieldName)
            if(indexValue2 > -1) this.checkedFields.splice(indexValue2,1)
          } else {
            this.fields.pop()
            this.fields.push(fieldName)
            this.fields.push("__slot:actions")
            this.checkedFields.push(fieldName)
          }
          // console.log(this.fields)
          this.$refs.vuetable.normalizeFields()
        },
        onCheckAllField(){
        },
        async massupdate(field_name,value){
          var field_update = {}
          field_update[field_name] = value
          var payload = {ids: this.checkedItems, field_update: field_update }
          var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update" , null, payload)
          if(response["message"] == "Ok"){
              this.successMessage = "Update successful!"
              this.$refs.vuetable.refresh()
              this.checkedItems = []
              this.$refs.vuetable.selectedTo = []
          } else {
              this.successMessage = "Update failed!"
              // alert("Error processing")
          }
        },
        async onPaginationData(paginationData) {
          paginationData.per_page = this.perPage
        //   await axios({
        //     method: 'PUT',
        //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
        //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
        // })
        console.log(paginationData)
        console.log(this.perPage)
          this.$refs.pagination.setPaginationData(paginationData);
          this.spinning = false;
          this.spinMessage = "Loading...";
        },
        async onLoadError(error){
          // request for new token or reauthenticate
          if(error.response.status == 401){
            var  auth_response = await HTTPRequest.authenticate(component_x.endPoint)
            if(auth_response["status"] == "Ok"){
              this.$router.go();
            }else{
              alert("Cannot get access token. Please login again.")
              this.$router.push("/")
            }
          }  else {
            if(error.response.data.error == "Session expired"){
                alert("Session is already expired. Please login again.")
                document.getElementById("logoutButton").click()
            } else if(error.response.data.error == "Invalid IP for Access Token"){
              alert("Invalid Access Token. Please login again.")
              document.getElementById("logoutButton").click()
            }
          }
        },
        onChangePage(page) {
          this.spinning = true;
          this.spinMessage = "Loading page " + page + ', Please wait...';
          this.$refs.vuetable.changePage(page);
          //this.spinning = false;
        },
        async deleteMultipleRow(){
          //Loop Check Items status
          var error = []
          for(var i = 0; i < this.checkedItems.length; i++) {
            var xx = this.$refs.vuetable.tableData.filter(x => x.id === this.checkedItems[i]);
            if(['Posted', 'Voided'].includes(xx[0]['status'])){
              error.push(xx[0]['document_no'])
            }
          }

          if(error.length > 0){
            component_x.errorMessage = 'Error voiding: Selected documents have posted/voided status. Document #: '+error.toString()+'.'
            return
          } else {
            //Loop Void Items
            for(var i = 0; i < this.checkedItems.length; i++) {
              await this.deleteRow(this.checkedItems[i],this.checkedItems[i])
            }
          }
        },
        async onChangePerPage(){
          var cur_page = this.$refs.vuetable.currentPage
          this.$refs.vuetable.currentPage = -1;
          await setTimeout(() => {
            this.onChangePage(cur_page)
          }, 500);
          // await this.onPaginationData()
        },
        async deleteRow(id,doc_no,doc_to = ''){
            this.spinning = true;
            this.spinMessage = 'Validating document for voiding ...'
            //[Internal] - Issue on voiding REL - 2972
            //Prevent voiding REL (STO) if target document (STI) is not yet voided.
            if(this.currentDocumentTypeCode == 'RELTRX'){
              //Check STI if Voided
              var sti_doc = await HTTPRequest.getRequest(this.endPoint + "documents/"+ id +"?field_name=origin_document_id", null);
              this.proceed_voiding = ((sti_doc != null && sti_doc.status == 'Voided') || sti_doc == null) ? 1 : 0;
            } 
            
            //Prevent voiding REC, if the cost layer has a movement. (For FIFO or LIFO costing method only)
            if(/^RE(C)/.test(this.currentDocumentTypeCode)){
              var credentials = await this.getAccountSettings()
              //Check Costing Method
              if (['FIFO','LIFO',''].includes(JSON.parse(credentials.value).documentCostingMethod)){
                //Check Cost layer if has a movement
                //Compare document line and cost layer
                var document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+ id +'?field_name=document_id&origin_sublocation=0', null)
                var cost_layer = await HTTPRequest.getRequest(this.endPoint + 'documents/get_document_cost_layer_details?document_id='+ id,null)

                var document_lines_qty = 0
                var cost_layer_qty = 0
                
                if (document_lines.length > 0){
                  document_lines.forEach( line => {
                    document_lines_qty += Number(line.quantity)
                  })
                }

                if (cost_layer.length > 0){
                  cost_layer.forEach( line => {
                    cost_layer_qty += Number(line.quantity)
                  })
                }
                this.proceed_voiding = (document_lines_qty != cost_layer_qty && cost_layer_qty != 0 && this.proceed_voiding == 0) ? 0 : 1;
              } else if (['BLENDED'].includes(JSON.parse(credentials.value).documentCostingMethod)){
                this.proceed_voiding = 1
              }
            }
            
            if(this.proceed_voiding == 0 && this.currentDocumentTypeCode == 'RELTRX'){
              this.errorMessage = "Please void the " + sti_doc.document_name + " # " + sti_doc.document_no + "(" + doc_to + ") first before voiding the " + component_x.selectedDocumentName +" #"+ doc_no + "."
            } else if(this.proceed_voiding == 0 && /^RE(C)/.test(this.currentDocumentTypeCode)){
              //this.errorMessage = "Unable to void " + component_x.selectedDocumentName +" # "+ doc_no +", the cost layer for this document has already moved." 
              var documentCostingMethod = JSON.parse(credentials.value).documentCostingMethod 
              this.$confirm({
                    title: "The cost layer for this document has already moved",
                    content: h => <div>If there is not enough inventory, it will obtain it from the layer using the {documentCostingMethod} costing method; however, if there is no more inventory, it will obtain the cost from the product's last received cost, or "landed cost." Click OK to continue.</div>,
                    onOk: () => {
                            this.proceed_voiding = 1;
                            this.deleteRow(id,doc_no,doc_to);
                        },
                    onCancel() {}
                        });
            } else {
              var endPoint = this.endPoint //For second api request(post action history)
              axios({
              method: 'delete',
              url: this.endPoint + 'documents/' + id,
              headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
              })
              .then(function (e) {
                var doc_no_response = e['data']['document_no']
                axios({
                  method: 'post',
                  url: endPoint + 'document_action_histories/',
                  data: {
                      action: "VOIDED",
                      action_at: moment(new Date()),
                      action_by: secureStorage.getItem("userName"),
                      document_id: id,
                      status: "D"
                  },
                  headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                  })
                  .then(function () {
                      component_x.successMessage = "Successfully voided " + component_x.selectedDocumentName +" #"+doc_no_response
                      component_x.$refs.vuetable.refresh()
                  })
                  .catch(function (e) {
                    console.log(e)
                    component_x.$refs.vuetable.refresh()
                });
              })
              .catch(function (e) {
                var err_msg = JSON.parse(e.request.response).error
                component_x.errorMessage = err_msg[0]
              });
          }
          this.spinning = false;
        },
        toTitleCase(str) {
          return str.replace(
            /\w\S*/g,
            text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
          );
        },
        arrayToCsv(data, fields, sentence_case_fields, isForColumnHeaders) {
          const csvRows = [];

          // Set headers
          csvRows.push(fields.map(field => field.title || field.name).join(','));

          // Normalize fields to handle nested properties
          const normalizedFields = fields.map(field => field.split('.')[0]);
          // Filter out excluded fields
          const excluded_fields = Object.keys(data[0]).filter(x => !normalizedFields.includes(x));
          data.forEach(f => {
              excluded_fields.forEach(e => delete f[e]);
          });

          // Prepare the CSV data
          // set the first header to "No." to match with primer's requirement in doc headers
          // add other document type in isForColumnHeaders array if included in primer's header customization requirement
          if(this.currentDocumentTypeCode != 'OTHPCN' && this.currentDocumentTypeCode != 'OTHPCV') {
            if (['RECADJ','RELADJ', 'ORIOCR'].includes(this.currentDocumentTypeCode)) {
              sentence_case_fields[0] = 'Document Date';
            } else if (this.accountName.toLowerCase().includes('piml') && this.currentDocumentTypeCode == 'OTHSRQ') {
              sentence_case_fields[0] = 'SR NO.';
            } else {
              if (this.accountName.toLowerCase().includes('piml')) {
                switch (this.currentDocumentTypeCode) {
                  case 'OTHSIN':
                    sentence_case_fields[0] = 'SI No.';
                    break;
                  case 'ORISOX':
                    sentence_case_fields[0] = 'SO No.';
                    break;
                  case 'OTHSRQ':
                    sentence_case_fields[0] = 'SR No.';
                    break;
                  case 'OTHTOV':
                    sentence_case_fields[0] = 'Document Date';
                    break;
                  default:
                    sentence_case_fields[0] = 'No.';
                    break;
                }
              } else {
              sentence_case_fields[0] = (isForColumnHeaders && this.currentDocumentTypeCode != 'OTHTOV') ? 'No.' : ((this.currentDocumentTypeCode == 'OTHTOV') ? 'Document Date' : '#');
              }
            }
          }
          const new_data = [sentence_case_fields];

          const formatNumber = (num) => {
            if (typeof num === 'number' || (!isNaN(num) && num !== null && num !== '')) {
              return parseFloat(num).toFixed(2);
            }
            return num;
          };

          for (const item of data) {
              const row = fields.map(field => {
                  const [mainField, subField] = field.split('.');
                  let value = item[mainField];

                  // check if value is a JSON string & parse it (this is for JSON values query on Export All to fix empty values)
                  if (typeof value === 'string' && value.startsWith('{') && value.endsWith('}') && subField) {
                      try {
                          value = JSON.parse(value);
                      } catch (e) {
                          // not valid JSON, continue with the string value
                      }
                  }

                  if (subField) {
                      value = value && value[subField] !== null ? value[subField] : '';
                  }

                  if (field === 'ordering_cost' || field === 'verification_variance_quantity' || field === 'shipment_ref_no') {
                      value = value
                  }

                  if (field === 'total_quantity') {
                    value = value
                  } else if (['formatted_amount_net', 'formatted_amount_gross', 'total_discount'].includes(field)) {
                    if (typeof value === 'string') {
                      value = value.replace(/"/g, '').replace(/,/g, '');
                    }
                    value = parseFloat(value);
                    if (!isNaN(value)) {
                      value = value.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
                    } else {
                      value = '';
                    }
                  }

                  return value !== undefined && value !== null ? value.toString().replace(/, /g, ' ') : '-';
              });
              new_data.push(row);
          }

          return new_data.map(row =>
            row.map(cell => {
              const value = cell !== undefined && cell !== null ? cell.toString() : '';
              return `"${value.replace(/"/g, '""')}"`;
            }).join(',')
          ).join('\n');
        },
        downloadBlob(content, filename, contentType) {
            // Create a blob
            var blob = new Blob([content], { type: contentType });
            var url = URL.createObjectURL(blob);

            // Create a link to download it
            var pom = document.createElement('a');
            pom.href = url;
            pom.setAttribute('download', filename);
            pom.click();
        },
        async download(todo){ // Must update other Profile Tables download function to be aligned
      
          if(todo == 0){
            console.log('*****')
            console.log(this.$refs.vuetable.tableData)
            console.log('*****')

            //arvs
            //Map header to data
            //Remove undefined (Tickbox, Images)
            var fields = this.fields.map(a => a.name).filter(x => x !== undefined)
            console.log(fields)
            //Convert Headers to Sentence Case
            var sentence_case_fields = fields.map(f => {
                let header = f.replace(/(^\w|[-_]\w)/g, g => g.replace(/[-_]/, ' ').toUpperCase()).replace("Id.label", "").trim();
                if (['ORIPOX','RECDEL','OTHPUR','ORIASN','RELRSR','OTHSBI'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Site" || header === "Target Site Name") {
                      header = "Deliver To";
                  }
                  if (header === "Formatted Amount Net") {
                      header = "Amount Net";
                  }
                  if (header === "Amount Net" && this.currentDocumentTypeCode == "OTHSBI") {
                      header = "Document Amount";
                  }
                  if (header === "Amount Net" && this.currentDocumentTypeCode == "OTHPUR") {
                      header = "Amount";
                  }
                  if (header === "Currency"){
                      header = "PIML Price Currency"
                  } 
                  if (header === "Ui Currency"){
                      header = "Ordering Cost Currency"
                  }
                  if (header === "Cas No") {
                      header = (this.currentDocumentTypeCode === 'OTHSBI') ? "Supplier Bill Cas Series" : this.currentDocumentTypeCode === 'RECDEL' ? "RR Cas Reference" : "Cas Series";
                  }
                  if (header === "Origin Document") {
                      header = this.currentDocumentTypeCode === 'OTHSBI' ? "RR/AOC#" : "Origin #";
                  }

                  if (header === "Country") {
                      header = "Country of Origin";
                  }
                  if (header === "Is Exported") {
                      header = "Export Status";
                  }                 
                  if (header === "Reference" && this.currentDocumentTypeCode === 'RELRSR') {
                      header = "Ref#";
                  }
                  if (header === "Order Source" && this.currentDocumentTypeCode === 'OTHSBI') {
                      header = "Source";
                  }
                }
                if (header === "Document No") {
                    header = "No.";
                }
                if (['OTHLIQ'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Site") {
                    header = "Liquidation For";
                  }
                  if (header === "Order Source") {
                    header = "Source";
                  }
                  if (header === "Reference 1") {
                    header = "Lessor/Mall Group";
                  }
                  if (header === "Formatted Amount Gross") {
                    header = "Gross Amount";
                  }
                  if (header === "Total Discount") {
                      header = "Discount Amount";
                  }
                  if (header === "Source Site") {
                    header = "Site";
                  }
                  if (header === "So B2b Customer") {
                    header = "Lessor";
                  }
                  if (header === "Formatted Amount Net") {
                    header = "Net Receivable";
                  }
                  if (header === "Formatted Net Sales") {
                    header = "Net Sales";
                  }
                  if (header === "Reference 2") {
                    header = "Month/Year";
                  }
                }
                if (['RELCSI'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Reference 2") {
                      header = "Liquidation #";
                  }
                  if (header === "So B2b Customer") {
                      header = "Customer";
                  }
                  if (header === "Formatted Amount Gross") {
                      header = "Gross Sales";
                  }
                  if (header === "Formatted Amount Net") {
                      header = "Net Sales";
                  }
                  if (header === "Discount Text") {
                      header = "Percentage Discount";
                  }
                  if (header === "Total Discount") {
                      header = "Discount";
                  }
                }
                if (this.currentDocumentTypeCode  === 'OTHSRQ' && this.accountName.toLowerCase().includes('piml')){
                  if (header === "Formatted Amount Net" ) {
                        header = "Sales Amount";
                  }
                  if (header === "Reference 1") {
                        header = "Customer PO#";
                  }
                  if (header === "Reference 2") {
                        header = "PILM PO#";
                  }
                  if (header === "Currency Id.code") {
                        header = "Sales Amount Currency";
                  }
                  if (header === "Ui Currency Id.code") {
                        header = "Purchase Amount Currency";
                  }
                  if (header === "Ordering Cost") {
                        header = "Purchase Amount";
                  }
                  if (header === "Payment Term Name") {
                        header = "Customer Payment Terms";
                  }
                  if (header === "Customer") {
                        header = "Customer Name";
                  }
                  if (header === "Supplier  Name") {
                        header = "Supplier";
                  }
                  if (header === "Shipping Method Name") {
                        header = "Shipment Mode (Incoterms)";
                  }
                  if (header === "Total Quantity") {
                        header = "SR Qty";
                  }
                  if (header === "Actual Quantity") {
                        header = "Actual Qty";
                  }
                  if (header === "Remaining Qty") {
                        header = "Balance Qty";
                  }
                  if (header === "Customer Country") {
                        header = "Order Source";
                  }
                }
                if (this.currentDocumentTypeCode  === 'RELTRX' || this.currentDocumentTypeCode  === 'RECTRX'){
                  if (header === "Formatted Amount Net") {
                      header = "Net Amount";
                  }
                  if (header === "Formatted Amount Gross") {
                      header = "Gross Amount";
                  }
                  if (header === "Cas No" && this.currentDocumentTypeCode  === 'RELTRX') {
                      header = "STO Cas Series";
                  }
                  if (header === "Cas No" && this.currentDocumentTypeCode  === 'RECTRX') {
                      header = "STI Cas Series";
                  }

                  if (header === "Shipping Method Name" && this.currentDocumentTypeCode  === 'RELTRX') {
                      header = "Shipping Method";
                  }
                }
                if (this.currentDocumentTypeCode  === 'OTHTOV'){
                  if (header === "Parent Origin Document") {
                        header = "STO Doc#";
                  }
                  if (header === "Verification Barcode") {
                        header = "Barcode";
                  }
                  if (header === "Origin Document") {
                        header = "STI Doc#";
                  }
                  if (header === "Verification Variance Quantity") {
                        header = "Variance Qty";
                  }
                }
                if (header === "Source Site Name") {
                  if (['RELTRX','RECTRX', 'OTHTOV'].includes(this.currentDocumentTypeCode)) {
                    header = "From";
                  }
                }
                if (header === "Target Site Name") {
                  if (['RELTRX','RECTRX','OTHTOV'].includes(this.currentDocumentTypeCode)) {
                    header = "To";
                  }
                }
                if (header === "Origin Sublocation") {
                    if (['RELTRX','RECTRX', 'OTHTOV'].includes(this.currentDocumentTypeCode)) {
                        header = (this.currentDocumentTypeCode === 'RELTRX' || this.currentDocumentTypeCode === 'RECTRX')  ? "Sublocation (From)" : "Sublocation";
                    }
                }
                if (['RECCSR'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Company") {
                      header = "SBU";
                  }
                  if (header === "Cas No") {
                      header = "CM Cas Reference";
                  }
                  if (header === "Order Source") {
                      header = "Source";
                  }
                  if (header === "Origin Document") {
                      header = "DD Reference No.";
                  }
                  if (header === "Formatted Amount Net") {
                      header = "Net Amount";
                  }
                  if (header === "Party Tax Type") {
                      header = "Customer Vat Type";
                  }
                  if (header === "Reference") {
                      header = "Reference 1";
                  }
                }
                if (['OTHSIN'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Company") {
                      header = "SBU";
                  }
                  if (header === "Cas No") {
                      header = "SI Cas Reference";
                  }
                  if (header === "So Ref No.label") {
                      header = "SO Reference No.";
                  }
                  if (header === "Origin Document") {
                      header = "DD Reference No.";
                  }
                  if (header === "Formatted Amount Net" && this.accountName.toLowerCase().includes('primerph')) {
                      header = "Net Amount";
                  }
                  if (header === "Formatted Vat Amount") {
                      header = "VAT Amount";
                  }
                  if (header === "Party Tax Type") {
                      header = "Customer Vat Type";
                  }
                  if (header === "Reference") {
                      header = "Reference 1";
                  }
                  if (header === "Origin Document Id.origin Reference") {
                      header = "SO Reference No.";
                  }
                }
                if (header === "Deleted At") {
                      header = "Voided/Cancelled Date";
                }
                if (header === "Brand Names") {
                      header = "Brand";
                }
                if (header === "Wms Status Name"){
                    header = "Wms Status";
                  }
                if (header === "Oc Ref No") {
                    header = "Oc Reference No";
                }
                if (header === "Shipment Ref No") {
                    header = "Shipment Reference No";
                }
                if (['RECADJ','RELADJ'].includes(this.currentDocumentTypeCode)) {
                    if (header === "Cas No")
                      header = "Cas Series #";
                    if (header === "Origin Document")
                      header = "Origin Doc";
                    if (header === "Created At")
                      header = "Creation Date";
                }

                if (['OTHPWS'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Site")
                    header = "Target Site";
                  if (header === "Brand Filter.label")
                    header = "Brand";
                  if (header === "Reference 1")
                    header = "Reference";
                  if (header === "Target Date")
                    header = "Effectivity Date";
                }

                // console.log(`Mapped header: ${header}`);

                if (['ORISOX','RELDDE'].includes(this.currentDocumentTypeCode)) {
                    if (header === "Cas No" && this.accountName.toLowerCase().includes('primerph'))
                      header = "Cas So Series";
                    if (header === "Formatted Amount Net")
                      if (this.accountName.toLowerCase().includes('piml')) {
                        header = "Sales Amount";
                      } else {
                        header = "Amount";
                      }
                    if (header === "Shipping Method Name" && this.accountName.toLowerCase().includes('primerph'))
                      header = "Shipment Mode";
                }

                if (['RELSLO', 'RECSLI'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Origin Sublocation")
                    header = "From";
                  if (header === "Target Sublocation")
                    header = "To";
                }

                if (['OTHPCV'].includes(this.currentDocumentTypeCode)) {
                    if (header === "Verification Barcode")
                      header = "Barcode";
                    if (header === "Formatted Amount Net")
                      header = "Total Amount";
                    if (header === "Target Sublocation")
                      header = "Sublocation";
                    if (header === "Verification Variance Quantity")
                      header = "Variance Quantity";
                }

                if (['OTHPCN'].includes(this.currentDocumentTypeCode)) {
                  if (header === "Party Receiver Name")
                     header = "Site";
                  if (header === "Formatted Amount Net")
                    header = "Total Amount";
                }
                if (this.accountName.toLowerCase().includes('piml')) {
                  if (['OTHSIN', 'ORISOX'].includes(this.currentDocumentTypeCode)) {
                    if (header === "SO Reference No.")
                     header = "SR#";
                    if (header === "DD Reference No.")
                    header = "SO#";
                    if (header === "SI Cas Reference")
                    header = "SI#";
                    if (header === "Reference 1")
                    header = "Customer PO#";
                    if (header === "Reference 2")
                    header = "PIML PO#";
                    if (header === "Customer")
                    header = "Customer Name";
                    if (header === "Formatted Amount Net")
                    header = "Sales Amount";
                    if (header === "Currency")
                    header = "Sales Amount Currency";
                    if (header === "Ui Currency")
                    header = "Purchase Amount Currency";
                    if (header === "Amount")
                    header = "Sales Amount";
                    if (header === "Payment Term Name")
                    header = ['ORISOX'].includes(this.currentDocumentTypeCode) ? "Customer Payment Terms" : "Payment Terms";
                    if (header === "Customer Country")
                      header = ['ORISOX'].includes(this.currentDocumentTypeCode) ? "Ordering Customer" : "Ordering Country";
                    if (header === "Ordering Cost")
                    header = "Purchase Amount";
                    if (header === "Remaining Qty")
                    header = "Balance Qty";
                    if (header === "Total Quantity" && ['OTHSIN'].includes(this.currentDocumentTypeCode))
                    header = "SI Quantity";
                    if (header === "Country")
                    header = "Country of Origin";
                    if (header === "Currency Id.code") 
                    header = "Sales Amount Currency";
                    if (header === "Ui Currency Id.code") 
                    header = "Purchase Amount Currency";
                    if (header === "Shipping Method Name") 
                    header = "Shipment Mode (INCOTERMS)";
                  }

                  if (['ORISOX'].includes(this.currentDocumentTypeCode)) {
                    if (header === "Origin Document")
                    header = "SR#";
                    if (header === "Cas No")
                    header = "SO#";
                    if (this.accountName.toLowerCase().includes('piml')){
                      if (header === "Total Quantity")
                      header = "SO Quantity";
                      if (header === "Actual Quantity")
                      header = "Actual Qty";
                      if (header === "Payment Term Name")
                      header = "Customer Payment Terms";
                      if (header === "Shipping Method Name")
                      header = "Shipment Mode (Incoterms)";
                    }
                    
                  }
                }
                if (['ORIOCR'].includes(this.currentDocumentTypeCode)) {
                    if (header === "Reference 3")
                    header = "Boxme Ref No.";
                    if (header === "Reference 2")
                    header = "Order No.";
                    if (header === "Reference")
                    header = "Omisell Ref No.";
                    if (header === "Formatted Amount Net")
                    header = "Net Amount";
                    if (header === "Oms Status Name")
                    header = "Oms Status";
                }

                
                return header;
            });

            if(this.exportSelection == "0"){
                this.onClose();
                var additional_parameters = this.parameters
                additional_parameters = additional_parameters.replace('?','&');
                const currentSiteFilter = `&site_id=${this.branchId}`;
                additional_parameters += currentSiteFilter;
                // baseUrl + additional_parameters ,
                this.spinning = true
                this.spinMessage = 'Fetching data, please wait...'
                var data = await HTTPRequest.getRequest(this.endPoint + "documents?document_type_id="+this.documentTypeDetails.documentTypeId+"&is_export=true&docType="+this.currentDocumentTypeCode+"&sort=id%7Cdesc&page=1&per_page=500"+additional_parameters);
                if(data['data'].length > 0){
                  var table_data = data['data']
                  this.successMessage = "Fetching has been done, converting to CSV, please wait..."
                } else {
                  this.errorMessage = "No data fetched!"
                }
                this.spinning = false
                this.spinMessage = 'Loading...'
            }else if(this.exportSelection == "2"){
              if (this.checkedItems.length == 0) {
                this.errors.push('No Selected Record(s)');
                return;
              }else {
                var table_data = []
                for(var i = 0; i < this.checkedItems.length; i++) {
                  var xx = this.$refs.vuetable.tableData.filter(x => x.id == this.checkedItems[i]);
                  if (xx){
                    table_data.push(xx[0])
                  }
                }
                if (table_data.length == 0){
                  this.errors.push('No Selected Record(s)');
                  return;
                }
              }
            } else if(this.exportSelection == "3"){
              // Export Selected on All Pages
              if (this.checkedItems.length === 0) {
                this.errors.push('No Selected Record(s)');
                return;
              } else {
                this.spinning = true;
                this.spinMessage = 'Fetching selected data across all pages, please wait...';

                var additional_parameters = this.parameters;
                additional_parameters = additional_parameters.replace('?', '&');

                var data = await HTTPRequest.getRequest(this.endPoint + "documents?document_type_id=" + this.documentTypeDetails.documentTypeId + "&is_export=true&docType=" + this.currentDocumentTypeCode + "&sort=id%7Cdesc&page=1&per_page=500" + additional_parameters);

                if (data['data'].length > 0) {
                  // filter only selected ids (checkedItems) from ALL pages
                  var table_data = data['data'].filter(x =>
                    this.checkedItems.includes(x.id)
                  );
                }

                this.spinning = false;
                this.spinMessage = 'Loading...';
              }
            } else if (this.exportSelection == "4"){
              // Export Based on Filters
              var additional_parameters = this.parameters
              additional_parameters = additional_parameters.replace('?', '&')

              // default ignored keys (system params)
              const ignoredKeys = [ 'filter_date_by', 'call_type', 'sort', 'page', 'per_page', 'document_type_id', 'docType', 'is_export' ];
              const params = new URLSearchParams(additional_parameters.replace(/^&/, ''));
              const searchDateFrom = params.get('searchDateFrom');
              const searchDateTo = params.get('searchDateTo');
              const hasDateFilter = !!(searchDateFrom || searchDateTo);

              // check for any other applied filters
              const hasOtherFilter = Array.from(params.entries()).some(([key, value]) => {
                return !ignoredKeys.includes(key)
                  && !['searchDateFrom', 'searchDateTo', 'date_from', 'date_to', 'created_from', 'created_to'].includes(key)
                  && value
                  && value.trim() !== '';
              });

              // allow export if date filter OR any other filter is present
              if (!hasDateFilter && !hasOtherFilter) {
                this.errors.push('Please apply at least one filter before exporting.');
                this.spinning = false;
                return;
              }

              this.spinning = true;
              this.spinMessage = 'Fetching filtered data, please wait...';

              var data = await HTTPRequest.getRequest(this.endPoint + "documents?document_type_id=" + this.documentTypeDetails.documentTypeId + "&is_export=true&docType=" + this.currentDocumentTypeCode + "&sort=id%7Cdesc&page=1&per_page=500" + additional_parameters)

              if (data['data'].length > 0) {
                var table_data = data['data']
                this.successMessage = "Filtered data fetched, exporting...";
              } else {
                this.errors.push('No filtered data found!');
                this.spinning = false
                return
              }

              this.spinning = false
              this.spinMessage = 'Loading...'
            } else {
              const tableData = this.$refs.vuetable && Array.isArray(this.$refs.vuetable.tableData) ? this.$refs.vuetable.tableData : [];

              if (!tableData || tableData.length === 0) {
                this.errors.push('No data available on this page to export!');
                this.spinning = false
                return;
              }

              var table_data = tableData;
            }

            var currentdate = new Date(); 
            var filename = secureStorage.getItem('documentTypeName') + "_" + (currentdate.getMonth()+1)  + "-"
                + currentdate.getDate() + "-" 
                + currentdate.getFullYear() + "@" 
                + currentdate.getHours()
                + currentdate.getMinutes()
                + currentdate.getSeconds();

                function quoteIfNeeded(value) {
                  if (typeof value === 'string' && value.includes(',')) {
                    return `"${value}"`;
                  }
                  return value;
                }

              // set the first header to "No." to match with primer's requirement in doc headers
              // add other document type here if included in the primer's header customization requirement
              const isForColumnHeaders = ['OTHPWS', 'OTHTOV', 'OTHLIQ', 'OTHSIN', 'RECTRX', 'RELTRX'].includes(this.currentDocumentTypeCode);

              table_data = table_data.map(row => {
                const newRow = { ...row };

                newRow.formatted_amount_net = quoteIfNeeded(newRow.formatted_amount_net);
                newRow.formatted_amount_gross = quoteIfNeeded(newRow.formatted_amount_gross);

                return newRow;
              });

              const myLogs = this.arrayToCsv(table_data, fields, sentence_case_fields, isForColumnHeaders);
              // console.log('*****')
              // console.log(myLogs)
              // console.log('*****')
              this.downloadBlob(myLogs, filename+'.csv', 'text/csv;charset=utf-8;');
              this.onClose();
              this.successMessage = "Download successful!";
              this.spinning = false
              this.spinMessage = 'Loading...'
              return
          } else {
            var payload = {}
            var additional_parameters = ""
            var baseUrl = this.endPoint + "documents/download?file_type="+((todo == 0) ? 'csv' : 'csv_ns')+'&document_type='+this.currentDocumentTypeCode;
            if(this.exportSelection == "0"){
              // All
              this.spinning = true
              this.spinMessage = 'Fetching data, please wait...'
              payload["type"] = "all"
              baseUrl = this.endPoint + "documents?document_type_id="+this.documentTypeDetails.documentTypeId+"&sort=id%7Cdesc&page=1&per_page=500"
              //additional_parameters = this.parameters

              const currentSiteFilter = `&site_id=${this.branchId}`;
              additional_parameters += currentSiteFilter;
            }else if(this.exportSelection == "1"){
              // Current Page
              var ids = this.$refs.vuetable.tableData.map(({id}) => id)
              payload["type"] = "current_page";
              if (ids == 0) {
                this.errors.push('No Record(s)');
                return;
              }else {
                payload["ids"] = ids
              }

            }else if(this.exportSelection == "2"){
              // Selected
              payload["type"] = "selected"
              if (this.checkedItems == 0) {
                this.errors.push('No Selected Record(s)');
                return;
              }else {
                payload["ids"] = this.checkedItems
              }
            }else{
              // Filtered
              payload["type"] = "filtered"
              additional_parameters = this.parameters
            }

            var exportFields = this.fields
            var cbIndex = this.fields.indexOf("__checkbox");
            if(cbIndex > -1) exportFields.splice(cbIndex,1)
            var actionIndex = this.fields.indexOf("__slot:actions");
            if(actionIndex > -1) exportFields.splice(actionIndex,1)

            payload["fields"] = exportFields
            additional_parameters = additional_parameters.replace('?','&');
          
            axios({
              url: baseUrl + additional_parameters ,
              method: 'POST',
              responseType: 'blob', // important
              headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
              data: payload,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.currentProfile+'.csv');
              document.body.appendChild(link);
              link.click();
              this.onClose();
              this.filterStatus = null
              this.successMessage = "Download successful"
            });
          }
          
        },
        displayMessage( message ){
          if(message["error"] != undefined){
            this.onClose()
            this.errorMessage = message["error"]
            this.successMessage = null
          }
        },
        removeMessage( type ){
          if(type == 'error'){
            this.errorMessage = null
            this.pcountErrorMessage = null
            this.TAErrorMessage = null
          }else
            this.successMessage = null
        },
        getWindowWidth(event) { //for fullscreen drawer
          this.windowWidth = window.innerWidth
        },
        deleteEcomOrder(data){
          this.documentEcomDrawerVisible = true
          this.documentDetails = data
          this.ecomAction = 'Void'
        },
        addExtraColumn: async function(data,code){
          if (this.isRestrictedDisplayTotalQuantity){
            data.findIndex(x => x.name == 'total_quantity')<0 ? data.push({ name: 'total_quantity', title: 'qty', sortField: 'total_quantity'}) : ''
          }
          if (code =="ORISOX" || code =="ORIOSOSRC" || code =="ORIOSO" || code == "RELDDESRC" || code == "RELDDE") {
            var index = data.findIndex(x => x.name == 'reference')
            index<0 ? data.push({ name: 'reference', title: this.documentReferences[0].name}) : data[index].title = this.documentReferences[0].name
          }
          if (this.isRestrictedDisplayAllReferences) {
    
            if (code == "RECDEL") {
                if (data.findIndex(x => x.name == 'reference_1') < 0) {
                    data.push({ name: 'reference_1', title: this.documentReferences[0].name });
                }
            }

            const ref1Index = data.findIndex(x => x.name == 'reference_1');

            ['reference_2', 'reference_3', 'reference_4', 'reference_5', 'reference_6', 'reference_7', 'reference_8', 'reference_9', 'reference_10']
                .forEach((ref, i) => {
                    if (data.findIndex(x => x.name == ref) < 0) {
                      if (ref1Index >= 0 && code!="OTHSRQ" && (code!="ORISOX" && this.accountName.toLowerCase().includes('primerph'))) {
                          data.splice(ref1Index + i + 1, 0, { name: ref, title: this.documentReferences[i + 1].name });
                      } else {
                          data.push({ name: ref, title: this.documentReferences[i + 1].name });
                      }
                    }
                });
          }


          if (this.isRestrictedDisplayRemarks){
            data.findIndex(x => x.name == 'remark')<0 ? data.push({ name: 'remark', title: 'Warehouse Remarks'}) : ''
          }
          if (this.isRestrictedDisplayShipOnTimeSLA){
            data.findIndex(x => x.name == '__slot:target_date')<0 ? data.push({name:"__slot:target_date", title: "Ship-on-Time SLA"}) : ''
          }
          return data
        },
        addCountSetCheckBox (cell, formatterParams){
          let id = cell.getRow().getData().id
          var button = ""
          var index = this.selectedPCount.findIndex(x => x.id == id)
          var status = index >= 0 ? 'checked' : ''
          button += '<input type="checkbox" id="' + id + '" '+status+' />'
          return button
        },
        selectPCountAction: function(e, cell){
          if(e.target.id == cell.getRow().getData().id && e.srcElement.checked!=undefined){
            if (e.srcElement.checked){
              this.selectedPCount.push(cell.getRow().getData())
            }else{
              var checkPCount = this.selectedPCount.findIndex(x => x.id == e.target.id)
              checkPCount>=0 ? this.selectedPCount.splice(checkPCount,1) : ''
            }
          }
        },
        async countSetClickNext() {
          if (this.selectedPCount.length > 0){
            this.$router.push({ name: 'document_form', params: { id: -1, pcount_data: this.selectedPCount, document_type_id: this.documentTypeDetails.documentTypeId,document_typex:this.documentTypex,documentTypeName:this.documentTypeDetails.documentTypeName,documentTypeCode:this.documentTypeDetails.documentTypeCode,documentTypeFriendlyCode:this.documentTypeDetails.documentTypeFriendlyCode } })
          }else{
            this.pcountErrorMessage = "select atleast one physical count document"
          }
        },
        SLAfunction(value) {
          let sDate = moment(new Date(value));
          if (((sDate - this.dateNow) / 36e5) < 24){
            return '<span class="text-success font-weight-bold ">'+value+'</span>'
          }else if (((sDate - this.dateNow) / 36e5) > 24 && ((value - this.dateNow) / 36e5) > 0){
            return '<span class="text-warning font-weight-bold ">'+value+'</span>'
          }else if (((sDate - this.dateNow) / 36e5) < 0){
            return '<span class="text-danger font-weight-bold ">'+value+'</span>'
          }else {
            return '<span class="font-weight-bold ">'+value+'</span>'
          }
        },
        async GenerateBatchPickingList() {
          var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/generate_batch_picking_list', null, {document_id:this.checkedItems})
          if(post_request["message"] == "Ok"){
            this.successMessage = "Generate successful!"
            this.$refs.vuetable.refresh()
            this.checkedItems = []
            this.$refs.vuetable.selectedTo = []
          } else {
            this.errorMessage = post_request["error"]
          }
        },
    },
    mounted: async function() {
        component_x = this;
        this.apiURL = this.currentApiURL;
        secureStorage.setItem("documentTypeInternalCode", this.$attrs["documentType"])
        this.documentTypex = this.$attrs["documentType"]
        this.documentTypeDetails = this.$attrs["documentTypeDetails"]

        var user_settings = await this.getUserSettings('ORISOX');
        if (user_settings.data[0]) this.isSourceMode = user_settings.data[0].settings_json.isSourceMode

        this.$nextTick(function() { //for fullscreen drawer
          window.addEventListener('resize', this.getWindowWidth);
          this.getWindowWidth()
        })
        await this.reload()
        this.apiURLUpdated = true
    },
    beforeDestroy() { //for fullscreen drawer
      window.removeEventListener('resize', this.getWindowWidth);
    },
  }
</script>

<style>
.tabulator-tableHolder {
  min-height: 50px!important;
}
</style>
